import React, { useEffect, useMemo, useState } from 'react'
import { supabase } from './supabaseClient'
import ObjectivoLucro from './ObjectivoLucro'
import { C, FONT } from './theme'
import { lerTudo } from './lerTudo'
import {
  Wallet, AlertTriangle, Plus, Trash2, Pencil, RefreshCw,
  ArrowDownRight, ArrowUpRight, Clock, Info, Save,
} from 'lucide-react'
import { SLOTS_TRANSITO } from './constants'
import { parseSaldoMarketplace } from './utils/parseFatura'

// TESOURARIA — em que semana e que falta dinheiro.
//
// Nao e o Lucro nem o Saldo de Facturas. O Lucro pergunta "esta compra
// compensou"; o Saldo pergunta "quanto devo contra quanto me devem". Aqui a
// pergunta e outra: DAQUI A QUANTAS SEMANAS E QUE A CONTA FICA A ZERO.
//
// Uma empresa com lucro fica sem dinheiro em Outubro se o que tem a receber
// chega a quarenta dias e o que tem a pagar sai na sexta. Por isso tudo aqui
// tem DATA — um total sem datas nao responde a pergunta nenhuma.

const fmt = (n) => Number(n || 0).toLocaleString('pt-PT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const iso = (d) => d.toISOString().slice(0, 10)
const dataCurta = (d) => new Date(d).toLocaleDateString('pt-PT', { day: '2-digit', month: '2-digit' })

const SEMANAS = 13   // um trimestre. Menos nao apanha o IVA; mais e adivinhacao.
// Prazo tipico entre a venda no marketplace e o dinheiro cair na conta. So se
// usa quando a venda foi lancada sem data de recebimento; havendo data real,
// manda ela.
const DIAS_PAGAMENTO_MARKETPLACE = 20

// Segunda-feira da semana a que uma data pertence.
const segundaDe = (data) => {
  const d = new Date(data)
  d.setHours(0, 0, 0, 0)
  const dow = (d.getDay() + 6) % 7   // 0 = segunda
  d.setDate(d.getDate() - dow)
  return d
}

// Todas as ocorrencias de um movimento recorrente dentro da janela.
//
// Guarda-se UMA linha com a recorrencia, e nao doze linhas iguais: o
// contabilista mete-se uma vez como mensal, e se o valor mudar muda-se num
// sitio so.
const ocorrencias = (mov, de, ate) => {
  const out = []
  const passo = { mensal: 1, trimestral: 3, anual: 12 }[mov.recorrencia]
  const inicio = new Date(mov.data + 'T00:00:00')
  const fim = mov.ate ? new Date(mov.ate + 'T00:00:00') : null

  if (!passo) {
    if (inicio >= de && inicio <= ate) out.push(new Date(inicio))
    return out
  }
  // Salta ate a primeira ocorrencia dentro da janela em vez de percorrer mes a
  // mes desde 2019 — uma renda antiga daria centenas de voltas inuteis.
  const d = new Date(inicio)
  let guarda = 0
  while (d < de && guarda++ < 600) d.setMonth(d.getMonth() + passo)
  while (d <= ate && guarda++ < 600) {
    if (!fim || d <= fim) out.push(new Date(d))
    d.setMonth(d.getMonth() + passo)
  }
  return out
}

export default function Tesouraria() {
  const [loading, setLoading] = useState(true)
  const [erro, setErro] = useState('')
  const [compras, setCompras] = useState([])
  const [encomendas, setEncomendas] = useState([])
  const [internos, setInternos] = useState(new Set())
  const [fornecedores, setFornecedores] = useState([])
  const [manuais, setManuais] = useState([])
  const [ivaDeclarado, setIvaDeclarado] = useState([])
  const [cfg, setCfg] = useState({ saldo: 0, saldoEm: iso(new Date()), ivaDias: 55, ivaDedutivelMes: 0, ivaPagos: new Set(), ivaReais: new Map() })
  // Mercadoria da casa e ritmo do marketplace — ao lado da tesouraria, nunca
  // somados a ela. Ver o comentario no cartao.
  const [mercadoria, setMercadoria] = useState({ custo: 0, unidades: 0, emTransito: 0 })
  const [mediaMarketplace, setMediaMarketplace] = useState(null)
  const [vendasMkt, setVendasMkt] = useState([])
  // ── SALDO NO MARKETPLACE ────────────────────────────────────────────────
  //
  // O marketplace retem o dinheiro das vendas B2C: uma parte fica em cativacao
  // (pendente), outra fica disponivel para pedir, e o que ja foi pedido fica em
  // transito. Sao ~2.600 EUR que o sistema nao conhecia de todo.
  //
  // E uma FOTOGRAFIA MANUAL, como a do banco, e pela mesma razao: nada aqui le
  // o painel deles. E como a do banco, fica FORA da projeccao semanal — a data
  // em que cada parcela sai da cativacao nao se sabe, e inventar uma data para
  // a poder meter numa semana era estragar o unico numero deste ecra que
  // responde a "em que semana falta dinheiro".
  const [mkt, setMkt] = useState({ pendente: 0, disponivel: 0, solicitado: 0, em: null })
  // O que ja foi lancado na Previsao e ainda nao foi marcado como recebido. Esse
  // dinheiro esta dentro do saldo do marketplace E dentro da projeccao: sem o
  // descontar, contava-se duas vezes.
  const [mktPorReceber, setMktPorReceber] = useState(0)
  const [colagem, setColagem] = useState(null)
  // A serie de fotografias, e os levantamentos que cairam na conta. Sao as duas
  // metades da mesma conta: o saldo sobe com as vendas e desce com o que se
  // levanta, portanto sem saber o que se levantou a subida do saldo nao diz
  // quanto se vendeu.
  const [historicoMkt, setHistoricoMkt] = useState([])
  const [recebimentosMkt, setRecebimentosMkt] = useState([])
  // As unidades que sairam do stock, e o custo de cada uma. Com a receita que a
  // serie do saldo ja da, sai o lucro por unidade medido em vez de estimado.
  const [snapsMkt, setSnapsMkt] = useState([])
  const [custoPorNomeMkt, setCustoPorNomeMkt] = useState(new Map())
  const [guardandoMkt, setGuardandoMkt] = useState(false)
  // Custo da mercadoria de encomendas que ainda nao foram compradas ao
  // fornecedor. Ver o comentario no quadro que o mostra.
  const [comprasPorFechar, setComprasPorFechar] = useState({ custo: 0, custoInterno: 0, encomendas: [] })
  // Que compra cobre que encomenda. Serve ao "Teu hoje" para saber quanto do
  // dinheiro de cada cliente ja esta prometido a uma factura lancada.
  const [ligacoes, setLigacoes] = useState([])
  const [semanaAberta, setSemanaAberta] = useState(null)
  const [guardandoSaldo, setGuardandoSaldo] = useState(false)
  const [novoMov, setNovoMov] = useState(null)

  const carregar = async () => {
    setLoading(true); setErro('')
    // Copia local: o `internos` do estado so fica disponivel no render seguinte,
    // e os blocos abaixo precisam dele ainda dentro desta funcao.
    let internosSet = new Set()
    try {
      const [cRes, eRes, pRes, fRes, mRes, cfgRes, ivaRes] = await Promise.all([
        supabase.from('compras_fornecedor')
          .select('id, numero_fatura, numero_interno, data_fatura, estado, fase, valor_total, valor_final_total, pago_1a_prestacao, pago_2a_prestacao, pago_1a_valor, pago_2a_valor, pago_1a_data, pago_2a_data, sinal_percentagem, fornecedor_id, data_envio_prevista'),
        supabase.from('encomendas')
          .select('id, numero_encomenda, cliente_nome, cliente_id, total_final, total_com_iva, total_sem_iva, desconto_valor, pago_1a_prestacao, pago_2a_prestacao, pago_1a_valor, pago_1a_data, pago_2a_data, sinal_escolhido, tipo_pagamento, estado, created_at, tempo_entrega_dias, data_envio, fatura_emitida_em'),
        supabase.from('perfis').select('id').eq('cliente_interno', true),
        supabase.from('fornecedores').select('id, nome, prazo_envio_dias'),
        supabase.from('movimentos_manuais').select('*').order('data'),
        // Traz-se a configuracao TODA do IVA, e nao so as chaves da tesouraria.
        // O ecra do IVA guarda ali dois valores por trimestre: se ja foi
        // entregue (iva_pago_ANO_Tn) e quanto foi mesmo (iva_real_ANO_Tn). Sem
        // os ler, um trimestre pago em Maio continuava a aparecer como devido
        // para sempre — e foi exactamente o que aconteceu na primeira abertura.
        supabase.from('config_sistema').select('chave, valor'),
        supabase.from('faturacao_declarada').select('ano, mes, valor_sem_iva, valor_com_iva, importado_em'),
      ])
      // O ivaRes faltava nesta lista, e era o pior que podia faltar: sem a
      // facturacao declarada o IVA a entregar aparece a zero, o cartao "do
      // Estado" desaparece, e o saldo passa a parecer todo nosso. E precisamente
      // o erro que o comentario da janela mais abaixo existe para evitar.
      //
      // O nome de cada leitura vai na mensagem — "permission denied" sozinho nao
      // diz a que tabela e, e sem isso nao se sabe por onde comecar.
      for (const [nome, r] of [['Compras', cRes], ['Encomendas', eRes], ['Contas internas', pRes],
                               ['Fornecedores', fRes], ['Movimentos manuais', mRes],
                               ['Configuração', cfgRes], ['Facturação declarada', ivaRes]]) {
        if (r.error) throw new Error(nome + ': ' + r.error.message)
      }
      setCompras(cRes.data || [])
      setEncomendas(eRes.data || [])
      setInternos(new Set((pRes.data || []).map(p => p.id)))
      internosSet = new Set((pRes.data || []).map(p => p.id))
      setFornecedores(fRes.data || [])
      setManuais(mRes.data || [])
      setIvaDeclarado(ivaRes.data || [])
      const m = new Map((cfgRes.data || []).map(r => [r.chave, r.valor]))
      const pagos = new Set()
      const reais = new Map()
      const ossPorTri = new Map()
      const ossPagos = new Set()
      for (const [k, v] of m) {
        // A marca de entregue e gravada como '1' pelo ecra do IVA, e nao como
        // 'true'. Comparar com o texto errado fazia o botao daquele ecra nao ter
        // efeito nenhum aqui — um trimestre marcado como pago continuava a
        // aparecer como divida na tesouraria, sem nada a explicar porque.
        // Aceitam-se os dois, para o dia em que alguem mude a convencao.
        if (k.startsWith('iva_pago_') && (v === '1' || v === 'true')) pagos.add(k.slice('iva_pago_'.length))
        if (k.startsWith('iva_real_') && v != null && v !== '') reais.set(k.slice('iva_real_'.length), Number(v))
        // O OSS do trimestre, posto no ecra do IVA. E imposto cobrado a
        // consumidores de outros Estados-Membros que vem SOMADO ao nacional no
        // mapa do Sage. Sai da conta mais cedo e para outro destino, por isso
        // aqui vale como saida propria — nao como parte do IVA portugues.
        // iva_oss_pago_ testado ANTES de iva_oss_: o prefixo mais curto tambem
        // casa com o mais longo, e o '1' da marca entrava como 1 € de OSS.
        if (k.startsWith('iva_oss_pago_')) { if (v === '1' || v === 'true') ossPagos.add(k.slice('iva_oss_pago_'.length)) }
        else if (k.startsWith('iva_oss_') && v != null && v !== '') ossPorTri.set(k.slice('iva_oss_'.length), Number(v))
      }
      setCfg({
        saldo: Number(m.get('tesouraria_saldo_banco') || 0),
        saldoEm: m.get('tesouraria_saldo_banco_em') || iso(new Date()),
        ivaDias: Number(m.get('tesouraria_iva_dias_apos_trimestre') || 55),
        ivaDedutivelMes: Number(m.get('iva_dedutivel_mensal') || 0),
        ivaPagos: pagos,
        ivaReais: reais,
        ivaOss: ossPorTri,
        ivaOssPagos: ossPagos,
      })
      setMkt({
        pendente: Number(m.get('marketplace_saldo_pendente') || 0),
        disponivel: Number(m.get('marketplace_saldo_disponivel') || 0),
        solicitado: Number(m.get('marketplace_saldo_solicitado') || 0),
        em: m.get('marketplace_saldo_em') || null,
      })
    } catch (e) { setErro(e.message || String(e)) }

    // ── O que ha em mercadoria, ao custo ───────────────────────────────────
    //
    // O lucro do B2B nao sai como dinheiro: reinveste-se em artigos, que a conta
    // interna compra ao custo. Sessenta unidades a caminho sao lucro que existe,
    // mas em forma de perfume — e so vira dinheiro quando sair no marketplace.
    //
    // AO CUSTO E NAO AO PRECO DE VENDA, de proposito: o preco muda de pais para
    // pais e dentro do mesmo pais, portanto qualquer valorizacao a venda seria
    // inventada. O custo e o dinheiro que la esta enterrado, e esse sabe-se.
    try {
      const { data: internosPerfis } = await supabase.from('perfis')
        .select('email').eq('cliente_interno', true)
      const emails = new Set((internosPerfis || []).map(p => String(p.email || '').toLowerCase()).filter(Boolean))
      if (emails.size > 0) {
        const prods = await lerTudo(
          () => supabase.from('Produtos')
            .select('id, Nome, Email_Cliente, Stock_Atual, Transito1_Qtd, Transito2_Qtd, Transito3_Qtd, Transito4_Qtd, Transito5_Qtd'),
          'id')
        const meus = (prods.data || []).filter(p =>
          p.Email_Cliente && emails.has(String(p.Email_Cliente).toLowerCase()))
        const custos = await lerTudo(
          () => supabase.from('produtos_internos').select('produto_nome, preco_custo'),
          'produto_nome')
        const custoPorNome = new Map((custos.data || [])
          .filter(r => r.preco_custo != null)
          .map(r => [r.produto_nome, Number(r.preco_custo)]))

        let custo = 0, unidades = 0, transito = 0
        for (const p of meus) {
          const c = custoPorNome.get(p.Nome)
          if (c == null) continue
          // STOCK NEGATIVO NAO ABATE MERCADORIA. Um stock negativo e um erro de
          // contagem, nao mercadoria a menos — e a somar tal como esta fazia o
          // total ficar ABAIXO do que esta em transito, que e impossivel:
          // apareceu "59 un ao custo · 60 a caminho" e foi assim que se
          // descobriu. Um engano de inventario nao pode apagar perfume que
          // existe noutra prateleira.
          const emArmazem = Math.max(0, Number(p.Stock_Atual || 0))
          const aCaminho = SLOTS_TRANSITO.reduce((s, n) => s + Math.max(0, Number(p[`Transito${n}_Qtd`] || 0)), 0)
          custo += (emArmazem + aCaminho) * c
          unidades += emArmazem + aCaminho
          transito += aCaminho
        }
        setMercadoria({ custo: Math.round(custo * 100) / 100, unidades, emTransito: transito })

        // ── AS UNIDADES QUE SAIRAM, PARA O LUCRO POR UNIDADE ──────────────
        //
        // O `produto_stock_snapshots` guarda o stock de cada artigo dia a dia.
        // Uma descida entre dois dias e uma venda — e a mesma leitura que o
        // calc-vendas-mensais ja faz para estimar a procura.
        //
        // As SUBIDAS ignoram-se: sao reposicoes, nao vendas ao contrario.
        setCustoPorNomeMkt(custoPorNome)
        const nomesMeus = meus.map(p => p.Nome)
        if (nomesMeus.length > 0) {
          const de45 = new Date(); de45.setDate(de45.getDate() - 45)
          const linhas = []
          // Aos pedacos, como o resto do ficheiro faz: um `in` com centenas de
          // nomes rebenta o comprimento do URL e a leitura falha inteira.
          for (let i = 0; i < nomesMeus.length; i += 100) {
            const { data: sn } = await supabase.from('produto_stock_snapshots')
              .select('produto_nome, cliente_email, snapshot_date, stock_lognow')
              .in('produto_nome', nomesMeus.slice(i, i + 100))
              .gte('snapshot_date', iso(de45))
            for (const s of (sn || [])) {
              // So as contas internas: o mesmo artigo existe para varios
              // clientes, e o stock deles nao e mercadoria nossa.
              if (s.cliente_email && emails.has(String(s.cliente_email).toLowerCase())) linhas.push(s)
            }
          }
          setSnapsMkt(linhas)
        }
      }
    } catch { /* sem mercadoria calculada, o cartao nao aparece */ }

    // ── O custo das encomendas que ainda nao foram compradas ───────────────
    //
    // A receita de uma encomenda entra JA — o que o cliente pagou vai para o
    // saldo, o que falta vai para "a receber", e o IVA dela vai para o Estado.
    // Mas o CUSTO so entra quando a compra ao fornecedor for lancada, o que
    // acontece um ou dois dias depois.
    //
    // Entre esses dois momentos o ecra mostra o Marco mais rico do que e. Nao
    // por erro de conta: porque as duas metades da mesma venda chegam em
    // momentos diferentes. Numa encomenda de 4.650 EUR sao uns 3.800 de
    // exagero, e dura ate ele fechar o pedido.
    //
    // Fica como AVISO e nao entra na projeccao — decisao do Marco, e e a certa:
    // o valor sabe-se, a data em que se paga ao fornecedor e que nao. Inventar
    // uma data era o unico modo de o meter numa semana, e adivinhar datas foi o
    // que evitamos neste ecra todo.
    try {
      const { data: ligadas } = await supabase.from('compras_fornecedor_encomendas')
        .select('compra_id, encomenda_id')
      setLigacoes(ligadas || [])
      const jaComprado = new Set((ligadas || []).map((l) => String(l.encomenda_id)))

      // Sessenta dias: uma encomenda antiga por ligar e um problema de registo,
      // nao uma compra por fazer, e arrastá-la para aqui era ruido permanente.
      const desde = new Date(Date.now() - 60 * 86400000).toISOString()
      const { data: encs } = await supabase.from('encomendas')
        .select('id, numero_encomenda, cliente_nome, cliente_id, estado, created_at, pago_1a_prestacao, fornecedor_id')
        .gte('created_at', desde)
      // AS NOSSAS TAMBEM CONTAM, mas de outra maneira.
      //
      // As dos clientes sao custo por sair contra receita ja contada — vao para
      // o quadro amarelo. As nossas sao stock que ja aparece em "Em mercadoria"
      // sem estar pago: a mercadoria e nossa mas o capital nela ainda nao.
      // Sem as separar, o equilibrio entre liquido e mercadoria dava a nossa
      // parte em stock maior do que e.
      const candidatas = (encs || []).filter((e) =>
        e.pago_1a_prestacao
        && !String(e.estado || '').startsWith('cancel')
        && !jaComprado.has(String(e.id)))

      if (candidatas.length > 0) {
        const ids = candidatas.map((e) => e.id)
        const { data: itens } = await supabase.from('encomenda_itens')
          .select('encomenda_id, produto_nome, quantidade').in('encomenda_id', ids)
        const nomes = [...new Set((itens || []).map((i) => i.produto_nome))]
        const custoPorNome = new Map()
        for (let i = 0; i < nomes.length; i += 200) {
          const { data: cs } = await supabase.from('produtos_internos')
            .select('produto_nome, preco_custo').in('produto_nome', nomes.slice(i, i + 200))
          for (const c of (cs || [])) if (c.preco_custo != null) custoPorNome.set(c.produto_nome, Number(c.preco_custo))
        }
        // OS PORTES TAMBEM SE PAGAM AO FORNECEDOR.
        //
        // Contavam-se so os artigos, e o quadro mostrava menos custo do que
        // vai mesmo sair — na encomenda do Ruben faltavam 56,25 EUR. Um quadro
        // que existe para dizer "atencao, ainda tens isto a pagar" nao pode
        // dizer um numero menor do que a verdade.
        const { data: forns } = await supabase.from('fornecedores')
          .select('id, portes_custo_por_unidade')
        const portesPorForn = new Map((forns || [])
          .map((f) => [String(f.id), f.portes_custo_por_unidade == null ? 0 : Number(f.portes_custo_por_unidade)]))
        const fornDaEnc = new Map(candidatas.map((e) => [e.id, String(e.fornecedor_id)]))

        const porEnc = new Map()
        for (const it of (itens || [])) {
          const c = custoPorNome.get(it.produto_nome)
          if (c == null) continue
          const qtd = Number(it.quantidade || 0)
          const portes = portesPorForn.get(fornDaEnc.get(it.encomenda_id)) || 0
          porEnc.set(it.encomenda_id, (porEnc.get(it.encomenda_id) || 0) + (c + portes) * qtd)
        }
        const todas = candidatas
          .map((e) => ({ id: e.id, numero: e.numero_encomenda, cliente: e.cliente_nome, custo: Math.round((porEnc.get(e.id) || 0) * 100) / 100, data: e.created_at, interno: internosSet.has(e.cliente_id) }))
          .filter((e) => e.custo > 0.01)
          .sort((a, b) => String(a.data).localeCompare(String(b.data)))
        const lista = todas.filter((e) => !e.interno)
        setComprasPorFechar({
          custo: Math.round(lista.reduce((s, e) => s + e.custo, 0) * 100) / 100,
          custoInterno: Math.round(todas.filter((e) => e.interno).reduce((s, e) => s + e.custo, 0) * 100) / 100,
          encomendas: lista,
        })
      } else setComprasPorFechar({ custo: 0, custoInterno: 0, encomendas: [] })
    } catch { /* sem estimativa, o quadro nao aparece */ }

    // Ritmo do marketplace — TEXTO, e nunca uma linha na projeccao. As vendas
    // sao registadas depois de acontecerem; meter uma media num quadro feito de
    // compromissos reais contaminava o numero todo. O Marco lanca a venda certa
    // como movimento manual quando ja a tem, e e assim que deve ser.
    try {
      const de = new Date(); de.setMonth(de.getMonth() - 3)
      const { data: vm } = await supabase.from('vendas_marketplace')
        .select('id, tipo, produto_nome, qtd, valor_faturado, valor_total, marketplace, data, data_recebimento, recebido_em')
        .gte('data', iso(de))
      const total = (vm || []).reduce((s, v) => s + Number(v.valor_faturado || 0), 0)
      if (total > 0) setMediaMarketplace(Math.round((total / 3) * 100) / 100)
      setVendasMkt(vm || [])
      // O que ja foi lancado e ainda nao foi recebido. SEM LIMITE DE DATA, ao
      // contrario da leitura acima: um lancamento de ha quatro meses que ainda
      // nao foi recebido continua a estar dentro do saldo do marketplace, e se
      // ficasse de fora desta soma aparecia contado duas vezes.
      //
      // So os de tipo 'produto': um servico e facturado ao cliente e nao passa
      // pelo marketplace, portanto nunca esta dentro daquele saldo.
      const { data: porReceber } = await supabase.from('vendas_marketplace')
        .select('valor_total').eq('tipo', 'produto').is('recebido_em', null)
      setMktPorReceber(Math.round(
        (porReceber || []).reduce((s, v) => s + Number(v.valor_total || 0), 0) * 100) / 100)

      // A serie e os levantamentos, para o ritmo medido pelo saldo. Quatro
      // meses chegam: a janela do ritmo sao 30 dias, e o resto e folga para o
      // dia em que se quiser olhar mais para tras.
      const de4 = new Date(); de4.setMonth(de4.getMonth() - 4)
      const [histRes, recRes] = await Promise.all([
        supabase.from('marketplace_saldo_historico')
          .select('data, pendente, disponivel, solicitado').gte('data', iso(de4)).order('data'),
        // Pelo `recebido_em` e nao pela data da venda: o que interessa e quando
        // o dinheiro SAIU do marketplace, porque e isso que faz o saldo descer.
        // Uma venda de Junho levantada em Setembro desce o saldo em Setembro.
        supabase.from('vendas_marketplace')
          .select('valor_total, recebido_em')
          .eq('tipo', 'produto').not('recebido_em', 'is', null).gte('recebido_em', iso(de4)),
      ])
      setHistoricoMkt(histRes.data || [])
      setRecebimentosMkt(recRes.data || [])
    } catch { /* sem media, nao se mostra nada */ }

    setLoading(false)
  }
  useEffect(() => { carregar() }, [])

  const guardarSaldo = async (valor, data) => {
    setGuardandoSaldo(true)
    await supabase.from('config_sistema').upsert([
      { chave: 'tesouraria_saldo_banco', valor: String(valor) },
      { chave: 'tesouraria_saldo_banco_em', valor: data },
    ], { onConflict: 'chave' })
    setGuardandoSaldo(false)
  }

  // Mudar um valor CARIMBA A DATA DE HOJE, pela mesma razao do saldo do banco:
  // quem escreve um numero novo esta a dizer "e isto que la esta agora", e uma
  // data velha por baixo de um valor novo e a forma de o proprio aviso de
  // fotografia velha deixar de avisar.
  const guardarMarketplace = async (v) => {
    setGuardandoMkt(true)
    await supabase.from('config_sistema').upsert([
      { chave: 'marketplace_saldo_pendente', valor: String(v.pendente) },
      { chave: 'marketplace_saldo_disponivel', valor: String(v.disponivel) },
      { chave: 'marketplace_saldo_solicitado', valor: String(v.solicitado) },
      { chave: 'marketplace_saldo_em', valor: v.em },
    ], { onConflict: 'chave' })

    // A fotografia tambem vai para a serie. `onConflict: 'data'` de proposito:
    // colar outra vez no mesmo dia corrige a linha desse dia. Se ficassem duas
    // linhas do mesmo dia, a diferenca entre elas entrava na conta das vendas
    // como se alguem tivesse comprado alguma coisa.
    await supabase.from('marketplace_saldo_historico').upsert([{
      data: v.em, pendente: v.pendente, disponivel: v.disponivel, solicitado: v.solicitado,
    }], { onConflict: 'data' })
    // Actualiza a serie em memoria sem ir buscar tudo outra vez.
    setHistoricoMkt(h => [
      ...h.filter(f => f.data !== v.em),
      { data: v.em, pendente: v.pendente, disponivel: v.disponivel, solicitado: v.solicitado },
    ].sort((a, b) => String(a.data).localeCompare(String(b.data))))
    setGuardandoMkt(false)
  }

  const alterarMkt = (campo, valor) => {
    const novo = { ...mkt, [campo]: valor, em: iso(new Date()) }
    setMkt(novo)
    guardarMarketplace(novo)
  }

  // ── Todos os movimentos futuros, com data ────────────────────────────────
  const { movimentos, atrasados, depois, ivaPorEntregar, inicio } = useMemo(() => {
    // A PROJECCAO ARRANCA NA DATA DO SALDO, e nao hoje. O que aconteceu antes ja
    // esta dentro do numero que o Marco escreveu — soma-lo outra vez contava-o
    // duas vezes. O que ficou pelo meio aparece em "atrasados" e nao desaparece.
    const arranque = new Date((cfg.saldoEm || iso(new Date())) + 'T00:00:00')
    const hoje = new Date(); hoje.setHours(0, 0, 0, 0)
    const inicio = segundaDe(arranque > hoje ? arranque : hoje)
    const fim = new Date(inicio); fim.setDate(fim.getDate() + SEMANAS * 7 - 1)

    const movs = []
    const atras = []
    // O QUE VEM DEPOIS DAS 13 SEMANAS, e nao se pode simplesmente deitar fora.
    //
    // O IVA trimestral sai cerca de 55 dias depois de fechar o trimestre,
    // portanto pode estar ate 21 semanas a frente — nenhuma janela razoavel o
    // apanha sempre. O 3.º trimestre de 2026 vence a 24/11 e a janela acabava a
    // 23: falhava por um dia, e seis mil euros desapareciam do ecra sem uma
    // palavra.
    //
    // Alargar a janela era adivinhacao. Mostra-se o que vem a seguir num quadro
    // proprio, que e o que permite guardar dinheiro com tempo.
    const dep = []
    // O IVA de TODOS os trimestres por entregar, tenham ou nao data dentro da
    // janela. Nao e uma despesa como as outras: e dinheiro que ja esta na conta
    // e nao e nosso — cobrou-se ao cliente para entregar ao Estado.
    //
    // Ver um saldo de 8.880 e pensar que sao 8.880 e o erro que rebenta com
    // empresas em Maio e em Novembro. Este numero existe para o impedir.
    const ivaAberto = []
    const horizonte = new Date(fim); horizonte.setMonth(horizonte.getMonth() + 6)
    const empurra = (m) => {
      if (m.data < iso(inicio)) atras.push(m)
      else if (m.data <= iso(fim)) movs.push(m)
      else if (m.data <= iso(horizonte)) dep.push(m)
    }

    const fornPorId = new Map(fornecedores.map(f => [String(f.id), f]))

    // ── ENTRADAS: o que os clientes ainda devem ────────────────────────────
    for (const e of encomendas) {
      if (String(e.estado || '').startsWith('cancel')) continue
      // Uma encomenda dada por concluida nao tem dinheiro a entrar, mesmo que
      // alguma marca de prestacao tenha ficado por carimbar. Contar por marcas
      // numa encomenda ja fechada era mostrar dinheiro a caminho que ninguem
      // espera.
      if (e.estado === 'concluido') continue
      if (internos.has(e.cliente_id)) continue   // conta interna nao traz dinheiro
      const total = Number(e.total_final ?? e.total_com_iva ?? 0)
      if (!(total > 0)) continue

      // Mesma regra de sempre: valor gravado > pagamento a 100% > sinal
      // escolhido > metade.
      const primeira = e.pago_1a_valor != null ? Number(e.pago_1a_valor)
        : String(e.tipo_pagamento) === '100' ? total
        : e.sinal_escolhido != null ? Number(e.sinal_escolhido)
        : total / 2
      const segunda = Math.max(0, Math.round((total - primeira) * 100) / 100)

      if (!e.pago_1a_prestacao) {
        // A 1.a confirma a encomenda: espera-se depressa.
        const d = new Date(e.created_at); d.setDate(d.getDate() + 7)
        empurra({
          tipo: 'entrada', data: iso(d), valor: Math.round(primeira * 100) / 100,
          fonte: 'cliente', titulo: (e.numero_encomenda || '') + ' · 1.ª prestação',
          detalhe: e.cliente_nome || '', certo: false,
        })
      }
      if (!e.pago_2a_prestacao && segunda > 0.01 && String(e.tipo_pagamento) !== '100') {
        // A 2.a paga-se ANTES DO ENVIO — dai a data ser a do envio previsto e
        // nao a da encomenda. Sem isto o dinheiro aparecia semanas antes de
        // existir, e a projeccao mentia sempre para o lado optimista.
        const d = new Date(e.created_at)
        d.setDate(d.getDate() + (Number(e.tempo_entrega_dias) || 25))
        empurra({
          tipo: 'entrada', data: iso(d), valor: segunda,
          fonte: 'cliente', titulo: (e.numero_encomenda || '') + ' · 2.ª prestação',
          detalhe: e.cliente_nome || '', certo: false,
        })
      }
    }

    // ── SAIDAS: o que se deve aos fornecedores ─────────────────────────────
    for (const c of compras) {
      if (c.estado === 'cancelado') continue
      // Em previsao o valor AINDA VAI MUDAR: a factura final da Plus Skill traz
      // os portes. Usa-se o melhor numero conhecido e marca-se a linha — um
      // valor aproximado assinalado vale mais do que um numero certo que nao
      // existe.
      const ehFinal = c.fase === 'final' && Number(c.valor_final_total) > 0
      const total = ehFinal ? Number(c.valor_final_total) : Number(c.valor_total || 0)
      if (!(total > 0)) continue

      const pct1 = Number(c.sinal_percentagem ?? 50) || 50
      const primeira = c.pago_1a_valor != null ? Number(c.pago_1a_valor) : total * pct1 / 100
      const segunda = Math.max(0, Math.round((total - primeira) * 100) / 100)
      const forn = fornPorId.get(String(c.fornecedor_id))
      const nomeForn = forn?.nome || 'Fornecedor'
      const prazo = Number(forn?.prazo_envio_dias) || 25
      const ref = c.numero_fatura || c.numero_interno || '—'

      if (!c.pago_1a_prestacao) {
        // A 1.a ao fornecedor paga-se para a encomenda seguir, portanto vence na
        // DATA DA FACTURA e nao hoje.
        //
        // Estava a ser posta sempre em `hoje`, e isso fazia duas coisas mas
        // nenhuma boa: enchia a primeira semana com pagamentos que ja deviam ter
        // saido ha um mes, e escondia-os do quadro dos atrasados — que e
        // precisamente onde tinham de aparecer, porque sao os que o fornecedor
        // esta a espera. Uma factura de Julho por pagar nao e uma saida desta
        // semana; e uma divida vencida.
        const dPrim = new Date(c.data_fatura || new Date())
        empurra({
          tipo: 'saida', data: iso(dPrim), valor: Math.round(primeira * 100) / 100,
          fonte: 'fornecedor', titulo: ref + ' · ' + pct1 + '%',
          detalhe: nomeForn, certo: ehFinal,
        })
      }
      if (!c.pago_2a_prestacao && segunda > 0.01 && pct1 < 100) {
        const d = c.data_envio_prevista
          ? new Date(c.data_envio_prevista)
          : (() => { const x = new Date(c.data_fatura || new Date()); x.setDate(x.getDate() + prazo); return x })()
        empurra({
          tipo: 'saida', data: iso(d), valor: segunda,
          fonte: 'fornecedor', titulo: ref + ' · restante',
          detalhe: nomeForn, certo: ehFinal,
        })
      }
    }

    // ── SAIDAS: o IVA trimestral ───────────────────────────────────────────
    //
    // O IVA nao e dinheiro nosso — e do Estado, e sai da conta como qualquer
    // outra despesa. Deixa-lo de fora fazia a projeccao parecer folgada
    // precisamente nos meses apertados.
    const porTrimestre = new Map()
    for (const d of ivaDeclarado) {
      const t = Math.floor((Number(d.mes) - 1) / 3) + 1
      const k = d.ano + '-T' + t
      const a = porTrimestre.get(k) || { ano: Number(d.ano), t, liquidado: 0, meses: 0 }
      a.liquidado += Number(d.valor_com_iva || 0) - Number(d.valor_sem_iva || 0)
      a.meses++
      porTrimestre.set(k, a)
    }
    for (const [, tri] of porTrimestre) {
      const chave = tri.ano + '_T' + tri.t
      // JA ENTREGUE = ja saiu da conta. Mostra-lo como devido nao e so um numero
      // a mais: empurra a projeccao inteira para baixo e faz parecer que ha um
      // buraco onde nao ha.
      if (cfg.ivaPagos?.has(chave)) continue
      // O valor REAL apurado manda sempre sobre a estimativa. A estimativa
      // aplica uma media de despesa dedutivel; o real e o que o contabilista
      // apurou, e nao ha razao nenhuma para preferir o palpite ao facto.
      const real = cfg.ivaReais?.get(chave)
      const temReal = real != null && Number.isFinite(real)
      // O OSS sai do liquidado ANTES de tudo. O mapa do Sage nao separa o IVA
      // estrangeiro do portugues, por isso sem esta linha a tesouraria pedia
      // para reservar imposto a mais e projectava UMA saida quando sao DUAS:
      // o T3/2026 liquidou 8.817,92 €, mas a Portugal vao 8.568,90 € e os
      // restantes 249,02 € vao para Espanha, um mes antes.
      // Com valor real apurado nao se volta a abater: o real ja e so o nacional.
      const oss = Number(cfg.ivaOss?.get(chave)) || 0
      const aEntregar = temReal ? real : (tri.liquidado - oss - cfg.ivaDedutivelMes * tri.meses)
      // A guia do OSS vence no fim do mes seguinte ao trimestre — antes do IVA
      // nacional, que leva os dias configurados. Duas guias, duas datas.
      if (oss > 0.01 && !cfg.ivaOssPagos?.has(chave)) {
        const dOss = new Date(tri.ano, tri.t * 3 + 1, 0)
        ivaAberto.push({ chave: chave + '_OSS', valor: Math.round(oss * 100) / 100, data: iso(dOss) })
        empurra({
          tipo: 'saida', data: iso(dOss), valor: Math.round(oss * 100) / 100,
          fonte: 'iva', titulo: 'IVA OSS ' + tri.t + '.º trimestre ' + tri.ano,
          detalhe: 'outros Estados-Membros · guia própria', certo: true,
        })
      }
      if (!(aEntregar > 0.01)) continue
      // Fim do trimestre + os dias configurados. A data legal nao esta cravada
      // no codigo de proposito — ver supabase/sql/tesouraria.sql.
      const fimTri = new Date(tri.ano, tri.t * 3, 0)
      const dPag = new Date(fimTri); dPag.setDate(dPag.getDate() + cfg.ivaDias)
      ivaAberto.push({ chave, valor: Math.round(aEntregar * 100) / 100, data: iso(dPag) })
      empurra({
        tipo: 'saida', data: iso(dPag), valor: Math.round(aEntregar * 100) / 100,
        fonte: 'iva', titulo: 'IVA ' + tri.t + '.º trimestre ' + tri.ano,
        detalhe: temReal ? 'valor apurado'
          : tri.meses < 3 ? ('estimativa · só ' + tri.meses + ' de 3 meses declarados')
          : 'estimativa',
        certo: temReal,
      })
    }

    // ── ENTRADAS: o marketplace ─────────────────────────────────────
    //
    // As vendas do marketplace lancam-se na Previsao — e a MESMA linha que
    // conta para a facturacao. Antes o dinheiro delas so entrava aqui se fosse
    // escrito outra vez como movimento manual, e era isso que acontecia: a
    // `vendas_marketplace` estava vazia e a entrada de 1.300 EUR vivia nos
    // manuais. A Tesouraria sabia; a previsao que vai para o contabilista nao
    // fazia ideia, e faltava-lhe um quarto das vendas do ano.
    //
    // A data que conta AQUI e a do recebimento, nao a da factura: uma venda de
    // 20 de Dezembro paga a 9 de Janeiro e facturacao de Dezembro e dinheiro de
    // Janeiro. Sao as duas datas da mesma linha.
    for (const v of vendasMkt) {
      // JA RECEBIDO NAO E ENTRADA FUTURA. O dinheiro esta no saldo do banco;
      // conta-lo outra vez aqui era soma-lo duas vezes.
      if (v.recebido_em) continue
      // O VALOR COM IVA. Esta projeccao e sobre dinheiro, e o que cai na conta
      // traz IVA — 836,40 e nao 680,00. O valor sem IVA e o que interessa a
      // facturacao e vive na Previsao, nao aqui.
      const valor = Number(v.valor_total ?? v.valor_faturado ?? 0)
      if (!(valor > 0)) continue
      const certo = !!v.data_recebimento
      const d = certo
        ? new Date(v.data_recebimento + 'T00:00:00')
        : (() => {
            const x = new Date(String(v.data) + 'T00:00:00')
            x.setDate(x.getDate() + DIAS_PAGAMENTO_MARKETPLACE)
            return x
          })()
      empurra({
        tipo: 'entrada', data: iso(d), valor: Math.round(valor * 100) / 100,
        fonte: 'marketplace',
        titulo: v.tipo === 'servico'
          ? 'Serviços prestados'
          : (v.marketplace || 'Marketplace') + (v.qtd ? ' · ' + v.qtd + ' un' : ''),
        detalhe: v.produto_nome || 'vários artigos',
        certo,
      })
    }

    // ── Movimentos manuais, com as recorrencias expandidas ─────────────────
    // O que ja aconteceu esta no saldo de hoje e nao se repete aqui.
    //
    // A janela comeca na segunda-feira desta semana, portanto apanha dias que ja
    // passaram. Um jantar lancado a quarta-feira estaria ao mesmo tempo dentro do
    // saldo estimado e outra vez como saida da semana — e a projeccao arranca do
    // saldo, portanto descontava-o duas vezes. Foi assim que os 369 EUR se
    // duplicaram uma vez; a regra e a mesma dos dois lados para nao voltarem a
    // divergir.
    // Tudo o que ja passou esta no saldo de hoje: ou dentro da fotografia do
    // banco (data <= data da fotografia), ou dentro do "mexeu-se desde entao"
    // (data posterior a ela e ate hoje). Nos dois casos ja foi descontado, e a
    // projeccao arranca do saldo — repeti-lo aqui descontava-o duas vezes.
    //
    // Isto assume que um movimento manual com data passada aconteceu mesmo. E o
    // que faz sentido para o que ele serve: lanca-se depois de pagar, nao antes.
    // Por isso tambem nao aparecem nos atrasados — nao ha nada em atraso num
    // gasto que ja saiu da conta.
    const hojeMovISO = iso(hoje)
    for (const m of manuais) {
      if (!m.activo) continue
      for (const d of ocorrencias(m, inicio, fim)) {
        const dISO = iso(d)
        if (dISO <= hojeMovISO) continue
        empurra({
          tipo: m.tipo, data: dISO, valor: Number(m.valor),
          fonte: 'manual', titulo: m.descricao,
          detalhe: m.recorrencia !== 'nenhuma' ? m.recorrencia : (m.notas || ''),
          certo: true,
        })
      }
    }

    movs.sort((a, b) => a.data.localeCompare(b.data))
    atras.sort((a, b) => a.data.localeCompare(b.data))
    dep.sort((a, b) => a.data.localeCompare(b.data))
    return { movimentos: movs, atrasados: atras, depois: dep, ivaPorEntregar: ivaAberto, inicio }
  }, [encomendas, compras, internos, fornecedores, manuais, vendasMkt, ivaDeclarado, cfg])

  // ── O QUE SE MEXEU DESDE A FOTOGRAFIA ────────────────────────────────────
  //
  // O saldo e uma fotografia com data: nada no sistema le o banco. Entre tirar a
  // fotografia e hoje, houve pagamentos marcados — e esses ficavam invisiveis.
  // Marcados como recebidos, portanto fora da projeccao; e posteriores a data do
  // saldo, portanto fora dele tambem. Dinheiro real a desaparecer do ecra.
  //
  // ESTRITAMENTE POSTERIORES a data do saldo, e nao "no mesmo dia ou depois".
  // Quando se copia o extracto do banco de hoje, o que foi pago hoje JA la esta:
  // soma-lo outra vez era contar duas vezes. E a mesma fronteira que separa o
  // passado do futuro em todo o resto do ecra.
  const desdeAFotografia = useMemo(() => {
    const corte = cfg.saldoEm
    if (!corte) return { entrou: 0, saiu: 0, linhas: [] }
    const linhas = []

    // As vendas e servicos recebidos depois da fotografia contam aqui, como os
    // pagamentos dos clientes. Sem isto, marcar uma venda como recebida tirava-a
    // da projeccao e nao a punha em lado nenhum — o dinheiro desaparecia do
    // ecra ate alguem ir ao banco copiar o saldo outra vez.
    for (const v of vendasMkt) {
      if (!v.recebido_em || String(v.recebido_em).slice(0, 10) <= corte) continue
      const valor = Number(v.valor_total ?? v.valor_faturado ?? 0)
      if (!(valor > 0)) continue
      linhas.push({
        tipo: 'entrada', valor: Math.round(valor * 100) / 100,
        titulo: v.tipo === 'servico' ? 'Serviços prestados' : (v.marketplace || 'Marketplace'),
        data: String(v.recebido_em).slice(0, 10),
      })
    }

    for (const e of encomendas) {
      if (String(e.estado || '').startsWith('cancel')) continue
      if (internos.has(e.cliente_id)) continue
      const total = Number(e.total_final ?? e.total_com_iva ?? 0)
      if (!(total > 0)) continue
      const primeira = e.pago_1a_valor != null ? Number(e.pago_1a_valor)
        : String(e.tipo_pagamento) === '100' ? total
        : e.sinal_escolhido != null ? Number(e.sinal_escolhido)
        : total / 2
      if (e.pago_1a_prestacao && e.pago_1a_data && String(e.pago_1a_data).slice(0, 10) > corte) {
        linhas.push({ tipo: 'entrada', valor: Math.round(primeira * 100) / 100, titulo: (e.numero_encomenda || '') + ' · 1.ª', data: String(e.pago_1a_data).slice(0, 10) })
      }
      if (e.pago_2a_prestacao && e.pago_2a_data && String(e.pago_2a_data).slice(0, 10) > corte) {
        const segunda = Math.max(0, Math.round((total - primeira) * 100) / 100)
        if (segunda > 0.01) linhas.push({ tipo: 'entrada', valor: segunda, titulo: (e.numero_encomenda || '') + ' · 2.ª', data: String(e.pago_2a_data).slice(0, 10) })
      }
    }

    for (const c of compras) {
      if (c.estado === 'cancelado') continue
      const ehFinal = c.fase === 'final' && Number(c.valor_final_total) > 0
      const total = ehFinal ? Number(c.valor_final_total) : Number(c.valor_total || 0)
      if (!(total > 0)) continue
      const pct1 = Number(c.sinal_percentagem ?? 50) || 50
      const primeira = c.pago_1a_valor != null ? Number(c.pago_1a_valor) : total * pct1 / 100
      const ref = c.numero_fatura || c.numero_interno || '—'
      if (c.pago_1a_prestacao && c.pago_1a_data && String(c.pago_1a_data).slice(0, 10) > corte) {
        linhas.push({ tipo: 'saida', valor: Math.round(primeira * 100) / 100, titulo: ref + ' · 1.ª', data: String(c.pago_1a_data).slice(0, 10) })
      }
      if (c.pago_2a_prestacao && c.pago_2a_data && String(c.pago_2a_data).slice(0, 10) > corte) {
        const segunda = c.pago_2a_valor != null ? Number(c.pago_2a_valor) : Math.max(0, total - primeira)
        if (segunda > 0.01) linhas.push({ tipo: 'saida', valor: Math.round(segunda * 100) / 100, titulo: ref + ' · resto', data: String(c.pago_2a_data).slice(0, 10) })
      }
    }

    // -- Movimentos manuais que JA aconteceram --------------------------
    // So contavam para a frente, na projeccao. Um gasto lancado com data de
    // ontem aparecia na semana e nao descontava do saldo — que e exactamente o
    // contrario do que se quer ao lanca-lo.
    //
    // E este o unico sitio onde o Marco pode dizer ao sistema uma coisa que ele
    // nao tem como saber. Um negocio fechado numa reuniao, um jantar pago pela
    // conta, uma transferencia que nao passou por nenhuma encomenda: nada disso
    // e previsivel e o dinheiro sai na mesma. Sem isto, a unica saida era
    // reescrever o saldo a mao e perder a fotografia.
    //
    // As recorrencias contam pelo mesmo criterio das outras linhas: uma renda
    // cuja data ja passou saiu da conta, tal como uma prestacao marcada como
    // paga saiu. O que ainda nao venceu fica para a projeccao.
    const hojeISO = iso(new Date())
    const deData = new Date(corte + 'T00:00:00')
    const ateData = new Date(hojeISO + 'T00:00:00')
    for (const m of manuais) {
      if (!m.activo) continue
      const v = Number(m.valor)
      if (!(v > 0)) continue
      for (const d of ocorrencias(m, deData, ateData)) {
        const dISO = iso(d)
        // Estritamente DEPOIS da fotografia: o que aconteceu no proprio dia ja
        // esta dentro do numero que o banco mostrou.
        if (dISO <= corte) continue
        linhas.push({
          tipo: m.tipo === 'entrada' ? 'entrada' : 'saida',
          valor: Math.round(v * 100) / 100,
          titulo: m.descricao || 'movimento manual',
          data: dISO,
        })
      }
    }

    linhas.sort((a, b) => a.data.localeCompare(b.data))
    return {
      entrou: Math.round(linhas.filter(l => l.tipo === 'entrada').reduce((s, l) => s + l.valor, 0) * 100) / 100,
      saiu: Math.round(linhas.filter(l => l.tipo === 'saida').reduce((s, l) => s + l.valor, 0) * 100) / 100,
      linhas,
    }
  }, [encomendas, compras, internos, manuais, vendasMkt, cfg.saldoEm])

  // O dinheiro que ha na conta HOJE: a fotografia mais o que se mexeu depois.
  // E daqui que a projeccao arranca — nao do numero escrito a mao ha duas
  // semanas.
  const saldoHoje = useMemo(
    () => Math.round((Number(cfg.saldo) + desdeAFotografia.entrou - desdeAFotografia.saiu) * 100) / 100,
    [cfg.saldo, desdeAFotografia])

  // ── O IVA que ainda nao esta em lado nenhum ──────────────────────────────
  //
  // O IVA declarado so conhece FACTURAS JA TIRADAS. Mas ha vendas feitas e
  // entregues cuja factura ainda nao saiu, e o IVA delas vai ter de ser pago na
  // mesma — so que mais tarde. Sem isto, o "do Estado" esta sistematicamente
  // em baixo, e e o numero que diz quanto do saldo nao e nosso.
  //
  // Dois grupos, e o segundo e o buraco entre os dois mundos:
  //
  //   POR FACTURAR — encomenda sinalizada, factura por tirar. O cliente ja
  //   pagou o sinal, portanto e venda certa; cancelamentos sao raros.
  //
  //   POR DECLARAR — factura ja tirada, mas o mes dela ainda nao tem linha na
  //   facturacao declarada. Sem este grupo a encomenda saia dos "por facturar"
  //   e ainda nao entrava nos declarados: desaparecia dos dois e o numero
  //   voltava a ficar em baixo, justamente no mes em que se facturou.
  const ivaLatente = useMemo(() => {
    const pad = (n) => String(n).padStart(2, '0')
    const triDoMes = (mes) => Math.floor((Number(mes) - 1) / 3) + 1

    // QUANDO e que cada mes foi importado do Sage, e que meses pertencem a
    // trimestres ja entregues ao Estado.
    const importadoEm = new Map()
    const mesesJaPagos = new Set()
    for (const d of ivaDeclarado) {
      const k = `${d.ano}-${pad(d.mes)}`
      if (d.importado_em) importadoEm.set(k, String(d.importado_em).slice(0, 10))
      if (cfg.ivaPagos?.has(`${d.ano}_T${triDoMes(d.mes)}`)) mesesJaPagos.add(k)
    }

    const porFacturar = []
    const porDeclarar = []

    for (const e of encomendas) {
      if (String(e.estado || '').startsWith('cancel')) continue
      if (internos.has(e.cliente_id)) continue
      // SINALIZADA: a 1.ª prestacao entrou. Antes disso a encomenda ainda pode
      // morrer, e uma que morre nao pode inflacionar uma divida ao Estado.
      if (!e.pago_1a_prestacao) continue

      // O IVA REAL, e nao 23% aplicado por cima. Assim as contas internas e as
      // isentas dao zero sozinhas, sem ninguem as marcar.
      const totCom = Number(e.total_final ?? e.total_com_iva ?? 0)
      const base = Number(e.total_sem_iva || 0) - Number(e.desconto_valor || 0)
      const iva = Math.round((totCom - base) * 100) / 100
      if (!(iva > 0.01)) continue

      if (!e.fatura_emitida_em) {
        // A data da factura aproxima-se pela data de envio: factura-se conforme
        // se entrega. Sem envio ainda, usa-se a entrega prevista.
        const dRef = e.data_envio
          ? new Date(e.data_envio)
          : (() => { const d = new Date(e.created_at); d.setDate(d.getDate() + (Number(e.tempo_entrega_dias) || 25)); return d })()
        porFacturar.push({ id: e.id, numero: e.numero_encomenda, cliente: e.cliente_nome, iva, data: iso(dRef) })
        continue
      }

      const dFactura = String(e.fatura_emitida_em).slice(0, 10)
      const k = dFactura.slice(0, 7)
      // Trimestre ja entregue: esse dinheiro saiu da conta e nao ha nada a
      // acompanhar. E a regra do Marco, e e a unica que faz o IVA sair de vez —
      // declarar um mes nao e paga-lo.
      if (mesesJaPagos.has(k)) continue

      // UMA FACTURA EMITIDA DEPOIS DA IMPORTACAO DO SEU MES NAO ESTA NA
      // DECLARACAO.
      //
      // Tentou-se antes comparar valores — o IVA das encomendas do mes contra o
      // declarado — e nunca podia funcionar: o declarado vem do mapa de vendas e
      // inclui marketplace e tudo o resto, portanto e quase sempre maior do que
      // as encomendas B2B sozinhas. Nao acusava diferenca nenhuma.
      //
      // A data da importacao responde a pergunta certa e sem ambiguidade. Iguala
      // conta como declarada: o mapa importa-se DEPOIS de emitir as facturas do
      // dia, portanto no mesmo dia ja la esta.
      const imp = importadoEm.get(k)
      if (!imp || dFactura > imp) {
        porDeclarar.push({
          id: e.id, numero: e.numero_encomenda, cliente: e.cliente_nome, iva,
          data: dFactura,
          motivo: imp ? `mês importado a ${new Date(imp).toLocaleDateString('pt-PT')}` : 'mês por importar',
        })
      }
    }

    porFacturar.sort((a, b) => a.data.localeCompare(b.data))
    porDeclarar.sort((a, b) => a.data.localeCompare(b.data))
    return {
      porFacturar, porDeclarar,
      totalPorFacturar: Math.round(porFacturar.reduce((s, x) => s + x.iva, 0) * 100) / 100,
      totalPorDeclarar: Math.round(porDeclarar.reduce((s, x) => s + x.iva, 0) * 100) / 100,
    }
  }, [encomendas, internos, ivaDeclarado, cfg.ivaPagos])

  // ── A projeccao, semana a semana ─────────────────────────────────────────
  const semanas = useMemo(() => {
    const out = []
    let acumulado = Number(saldoHoje) || 0
    for (let i = 0; i < SEMANAS; i++) {
      const de = new Date(inicio); de.setDate(de.getDate() + i * 7)
      const ate = new Date(de); ate.setDate(ate.getDate() + 6)
      const dentro = movimentos.filter(m => m.data >= iso(de) && m.data <= iso(ate))
      const entra = dentro.filter(m => m.tipo === 'entrada').reduce((s, m) => s + m.valor, 0)
      const sai = dentro.filter(m => m.tipo === 'saida').reduce((s, m) => s + m.valor, 0)
      acumulado += entra - sai
      out.push({
        i, de, ate,
        entra: Math.round(entra * 100) / 100,
        sai: Math.round(sai * 100) / 100,
        movimento: Math.round((entra - sai) * 100) / 100,
        saldo: Math.round(acumulado * 100) / 100,
        itens: dentro,
      })
    }
    return out
  }, [movimentos, inicio, saldoHoje])

  // ── ONDE ACABA O QUE ESTA COMPROMETIDO ───────────────────────────────────
  //
  // A ultima semana com movimento de cliente ou de fornecedor. Dai para a
  // frente so ha despesas recorrentes e o IVA — nada que dependa de encomendas.
  //
  // A tabela mostrava a semana de 05/10 igual a de 31/08, e dizem coisas
  // opostas: numa entram 11.802 EUR porque estao encomendados, na outra esta
  // zero porque AINDA NINGUEM ENCOMENDOU. Sem essa distincao, dez semanas quase
  // vazias leem-se como "isto vai correr mal", quando sao apenas o pior caso —
  // o que se sabe, sem nada do que ha-de aparecer.
  //
  // NAO E UM NUMERO FIXO. E a fronteira real do livro de encomendas, e
  // desloca-se sozinha: fechar uma encomenda com entrega em Outubro faz mais
  // semanas passarem a firmes.
  const ultimaSemanaFirme = useMemo(() => {
    let ultima = -1
    for (const s of semanas) {
      if (s.itens.some(m => m.fonte === 'cliente' || m.fonte === 'fornecedor')) ultima = s.i
    }
    return ultima
  }, [semanas])

  const totais = useMemo(() => {
    const receber = movimentos.filter(m => m.tipo === 'entrada').reduce((s, m) => s + m.valor, 0)
    const pagar = movimentos.filter(m => m.tipo === 'saida').reduce((s, m) => s + m.valor, 0)
    // O IVA por entregar, todo. E o que ja se cobrou e ainda nao se pagou.
    const ivaTotal = ivaPorEntregar.reduce((s, q) => s + q.valor, 0)
    // A parte que ja esta descontada na projeccao, por vencer dentro da janela.
    // Sem isto, descontava-se duas vezes: uma como saida da semana e outra como
    // reserva — e o numero final ficava pior do que a realidade.
    const ivaNaJanela = movimentos.filter(m => m.fonte === 'iva').reduce((s, m) => s + m.valor, 0)
    const ivaPorDescontar = Math.max(0, ivaTotal - ivaNaJanela)
    // O IVA latente NAO esta na projeccao — nao tem data de saida porque a
    // factura ainda nao existe. Desconta-se por inteiro, sem risco de o tirar
    // duas vezes.
    const latente = ivaLatente.totalPorFacturar + ivaLatente.totalPorDeclarar
    const liquida = Math.round((Number(saldoHoje) + receber - pagar) * 100) / 100
    return {
      receber: Math.round(receber * 100) / 100,
      pagar: Math.round(pagar * 100) / 100,
      liquida,
      ivaFacturado: Math.round(ivaTotal * 100) / 100,
      ivaLatente: Math.round(latente * 100) / 100,
      ivaTotal: Math.round((ivaTotal + latente) * 100) / 100,
      ivaPorDescontar: Math.round((ivaPorDescontar + latente) * 100) / 100,
      // O que sobra depois de o Estado levar o que e dele — o ja facturado e o
      // que so falta facturar.
      teu: Math.round((liquida - ivaPorDescontar - latente) * 100) / 100,
      primeiraNegativa: semanas.find(s => s.saldo < 0),
      atrasadoEntrada: atrasados.filter(m => m.tipo === 'entrada').reduce((s, m) => s + m.valor, 0),
      atrasadoSaida: atrasados.filter(m => m.tipo === 'saida').reduce((s, m) => s + m.valor, 0),
    }
  }, [movimentos, semanas, saldoHoje, atrasados, ivaPorEntregar, ivaLatente])

  // O MESMO FORMULARIO CRIA E EDITA.
  //
  // Antes so criava. Uma linha mal escrita — a entrada de 1.300 EUR que dizia
  // "Vendas B2B" e afinal era outra coisa — corrigia-se apagando e voltando a
  // escrever. Numa recorrencia isso e pior do que parece: perde-se a data da
  // primeira vez e a do fim, que sao o que decide em que semanas ela aparece.
  // Quem so queria mudar duas palavras acabava com a projeccao diferente.
  // ── QUANTO SE VENDEU MESMO, MEDIDO PELO SALDO ─────────────────────────────
  //
  //   vendas do periodo = (saldo no fim - saldo no inicio) + o que se levantou
  //
  // O saldo sobe com cada venda e desce com cada levantamento. Sabendo as duas
  // pontas e o que saiu pelo meio, o que entrou sai por diferenca — sem ser
  // preciso lancar venda nenhuma, e sem o atraso de vinte dias que ha entre
  // vender e receber.
  //
  // ISTO SO E VERDADE SE OS LEVANTAMENTOS ESTIVEREM TODOS LANCADOS. Um
  // levantamento que caia na conta e fique por marcar faz o saldo descer sem
  // explicacao, e a conta le essa descida como se se tivesse vendido menos. E a
  // unica forma de este numero mentir, e mente sem dar sinal — por isso o ecra
  // diz de quantos levantamentos depende.
  const ritmoMkt = useMemo(() => {
    if (historicoMkt.length < 2) return null
    const serie = [...historicoMkt].sort((a, b) => String(a.data).localeCompare(String(b.data)))
    const fim = serie[serie.length - 1]
    // Janela de 30 dias, ou a serie toda enquanto ela for mais curta do que isso.
    const limite = iso(new Date(new Date(fim.data + 'T00:00:00').getTime() - 30 * 86400000))
    const inicio = serie.find(f => f.data >= limite) || serie[0]
    if (inicio.data === fim.data) return null

    const soma = (f) => Number(f.pendente || 0) + Number(f.disponivel || 0) + Number(f.solicitado || 0)
    const variacao = Math.round((soma(fim) - soma(inicio)) * 100) / 100
    // ESTRITAMENTE DEPOIS da fotografia inicial: um levantamento do proprio dia
    // ja esta dentro do saldo que essa fotografia mostra, e somá-lo contava-o
    // duas vezes. E a mesma regra do "desde a fotografia" do saldo do banco.
    const doPeriodo = recebimentosMkt.filter(r => r.recebido_em > inicio.data && r.recebido_em <= fim.data)
    const levantado = Math.round(doPeriodo.reduce((s, r) => s + Number(r.valor_total || 0), 0) * 100) / 100
    const dias = Math.round((new Date(fim.data + 'T00:00:00') - new Date(inicio.data + 'T00:00:00')) / 86400000)
    const vendido = Math.round((variacao + levantado) * 100) / 100

    return {
      vendido, variacao, levantado, dias,
      de: inicio.data, ate: fim.data,
      levantamentos: doPeriodo.length,
      fotografias: serie.filter(f => f.data >= inicio.data).length,
      // Por mes, para comparar com o que quer que seja. So se extrapola a partir
      // de uma semana: tres dias de serie vezes dez e adivinhacao com ar de
      // conta feita.
      porMes: dias >= 7 ? Math.round((vendido / dias) * 30 * 100) / 100 : null,
    }
  }, [historicoMkt, recebimentosMkt])

  // ── LUCRO POR UNIDADE, MEDIDO ─────────────────────────────────────────────
  //
  // O lucro por unidade era o numero mais importante da conta do fim do ano e o
  // unico que vinha de cabeca. Trocar 35 EUR por 20 EUR mexeu 1.500 EUR no
  // resultado — e nenhum dos dois era medido.
  //
  // As tres pecas ja existem, so nunca tinham sido juntas:
  //
  //   unidades  ->  as descidas do stock nos snapshots
  //   receita   ->  a variacao do saldo do marketplace mais os levantamentos
  //   custo     ->  unidades x preco_custo de cada artigo
  //
  // Nao e uma media dos artigos: e o lucro REAL do periodo dividido pelas
  // unidades REAIS que sairam. Uma venda a 175 e outra a 125 entram as duas
  // pelo que valeram, sem ninguem ter de decidir qual e a tipica.
  const lucroUnidade = useMemo(() => {
    if (!ritmoMkt) return null
    const dentro = snapsMkt.filter(s =>
      s.stock_lognow != null && s.snapshot_date >= ritmoMkt.de && s.snapshot_date <= ritmoMkt.ate)
    if (dentro.length === 0) return null

    const porProduto = new Map()
    for (const s of dentro) {
      const k = s.produto_nome
      if (!porProduto.has(k)) porProduto.set(k, [])
      porProduto.get(k).push(s)
    }

    let unidades = 0, custo = 0, unidadesSemCusto = 0
    for (const [nome, lista] of porProduto) {
      lista.sort((a, b) => String(a.snapshot_date).localeCompare(String(b.snapshot_date)))
      let prev = null, vendidas = 0
      for (const s of lista) {
        const cur = Number(s.stock_lognow)
        // So as descidas. Uma subida e reposicao, e conta-la como venda
        // negativa apagava vendas verdadeiras de outro dia.
        if (prev !== null && cur < prev) vendidas += prev - cur
        prev = cur
      }
      if (vendidas <= 0) continue
      unidades += vendidas
      const c = custoPorNomeMkt.get(nome)
      if (c == null) unidadesSemCusto += vendidas
      else custo += vendidas * c
    }
    if (unidades === 0) return null

    // A receita do saldo vem com IVA; o custo e sem. Sem esta divisao o lucro
    // aparecia inflacionado em 23% da receita.
    const receita = Math.round((ritmoMkt.vendido / 1.23) * 100) / 100
    custo = Math.round(custo * 100) / 100
    const lucro = Math.round((receita - custo) * 100) / 100
    return {
      unidades, custo, receita, lucro, unidadesSemCusto,
      porUnidade: Math.round((lucro / unidades) * 100) / 100,
      dias: ritmoMkt.dias,
    }
  }, [ritmoMkt, snapsMkt, custoPorNomeMkt])


  const guardarMovimento = async () => {
    const v = Number(String(novoMov?.valor ?? '').replace(',', '.'))
    if (!novoMov?.descricao?.trim() || !(v > 0)) return
    const campos = {
      descricao: novoMov.descricao.trim(),
      valor: v,
      tipo: novoMov.tipo,
      data: novoMov.data,
      recorrencia: novoMov.recorrencia,
      ate: novoMov.ate || null,
      notas: novoMov.notas || null,
      conta_no_lucro: novoMov.contaNoLucro !== false,
    }
    const { error } = novoMov.id
      ? await supabase.from('movimentos_manuais').update(campos).eq('id', novoMov.id)
      : await supabase.from('movimentos_manuais').insert(campos)
    if (error) setErro(error.message)
    else { setNovoMov(null); await carregar() }
  }

  const editarMovimento = (m) => {
    setErro('')
    setNovoMov({
      id: m.id,
      contaNoLucro: m.conta_no_lucro !== false,
      descricao: m.descricao || '',
      valor: String(m.valor ?? ''),
      tipo: m.tipo || 'saida',
      data: String(m.data || '').slice(0, 10),
      recorrencia: m.recorrencia || 'nenhuma',
      ate: m.ate ? String(m.ate).slice(0, 10) : '',
      notas: m.notas || '',
    })
    // O formulario abre ACIMA da lista. Sem isto, carregar no lapis de uma
    // linha la em baixo nao parecia fazer nada.
    setTimeout(() => document.getElementById('form-movimento')
      ?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 50)
  }

  const apagarMovimento = async (id) => {
    if (!confirm('Apagar este movimento?')) return
    await supabase.from('movimentos_manuais').delete().eq('id', id)
    await carregar()
  }

  // O total do marketplace e a SOMA DAS PARCELAS e nao um numero gravado: o
  // painel deles tambem mostra um total, mas gravar os dois deixava-os capazes
  // de discordar entre si. O que se confere na leitura e a soma; o que se
  // mostra e a mesma soma.
  const mktTotal = Math.round((mkt.pendente + mkt.disponivel + mkt.solicitado) * 100) / 100
  const naoContado = Math.round((mktTotal - mktPorReceber) * 100) / 100

  // ── EQUILIBRIO ENTRE LIQUIDO E MERCADORIA ─────────────────────────────────
  //
  // Politica do Marco: metade do valor da empresa em dinheiro, metade em
  // mercadoria. Demasiado liquido e dinheiro parado que nao trabalha; demasiada
  // mercadoria e lucro do B2B encravado em prateleira — que foi como o
  // concorrente alemao acabou com 120 unidades a vender ao custo.
  //
  // O QUE NAO ESTA PAGO ABATE-SE A MERCADORIA e nao ao dinheiro. Um artigo em
  // transito que ainda nao foi facturado aparece em "Em mercadoria", mas o
  // capital nele ainda nao e nosso: temos o frasco e devemo-lo. O nosso valor
  // nessas unidades e zero, e e assim que tem de entrar na conta — senao o lado
  // da mercadoria aparece inflacionado pelo que ainda se deve.
  const equilibrio = useMemo(() => {
    const liquido = Math.round((totais.teu - comprasPorFechar.custo + naoContado / 1.23) * 100) / 100
    const stock = Math.round((mercadoria.custo - comprasPorFechar.custoInterno) * 100) / 100
    const total = Math.round((liquido + stock) * 100) / 100
    if (!(total > 0)) return null
    return {
      liquido, stock, total,
      pctLiquido: Math.round((liquido / total) * 1000) / 10,
      pctStock: Math.round((stock / total) * 1000) / 10,
    }
  }, [totais.teu, comprasPorFechar.custo, comprasPorFechar.custoInterno, mercadoria.custo, naoContado])

  // ── O QUE E TEU HOJE ──────────────────────────────────────────────────────
  //
  // Tudo o resto neste ecra e a treze semanas: conta o que os clientes ainda
  // vao pagar e o que ainda vai sair. O Marco pediu o de HOJE — o que ha na
  // conta que nao esta prometido a ninguem — para abrir o ecra de manha e
  // saber como esta a empresa sem fazer a conta a mao, que era o que acontecia.
  //
  // E a conta que se fez a mao a 16/09/2026 e deu 1.797 EUR:
  //
  //     banco + marketplace por receber
  //   − IVA ja facturado (Sage + facturas emitidas depois da importacao)
  //   − dinheiro dos clientes que ainda vai para o fornecedor
  //
  // O IVA das encomendas por facturar NAO entra: ainda nao e divida, e a
  // factura pode sair num trimestre ou no outro. As 2.as prestacoes por receber
  // tambem nao: nao estao na conta. Aparecem por baixo como "a caminho".
  //
  // "Dinheiro dos clientes que ainda vai para o fornecedor" e o que eles ja
  // pagaram por encomendas cuja compra nao esta paga, ate ao limite do que se
  // deve. Numa compra ja lancada com sinal pago, o que o cliente pagou acima
  // desse sinal esta prometido ao resto da factura; o que faltar vem da 2.a
  // prestacao, que nao esta na conta e por isso nao se desconta. Numa compra
  // ainda por lancar, desconta-se o que entrou ate ao custo estimado — a
  // margem de uma encomenda paga a 100% e do Marco, nao do fornecedor.
  const teuHoje = useMemo(() => {
    const recebido = (e) => {
      const total = Number(e.total_final ?? e.total_com_iva ?? 0)
      const primeira = e.pago_1a_valor != null ? Number(e.pago_1a_valor)
        : String(e.tipo_pagamento) === '100' ? total
        : e.sinal_escolhido != null ? Number(e.sinal_escolhido)
        : total / 2
      let r = 0
      if (e.pago_1a_prestacao) r += primeira
      if (e.pago_2a_prestacao) r += Math.max(0, total - primeira)
      return Math.min(r, total)
    }
    const conta = (e) => e && !internos.has(e.cliente_id) && !String(e.estado || '').startsWith('cancel')
    const porEnc = new Map(encomendas.map((e) => [String(e.id), e]))
    const encsDaCompra = new Map()
    for (const l of ligacoes) {
      const k = String(l.compra_id)
      if (!encsDaCompra.has(k)) encsDaCompra.set(k, new Set())
      encsDaCompra.get(k).add(String(l.encomenda_id))
    }

    const linhas = []
    let prometido = 0
    for (const c of compras) {
      if (String(c.estado) === 'pago_total') continue
      const total = Number(c.valor_final_total ?? c.valor_total ?? 0)
      const pago = (c.pago_1a_prestacao ? Number(c.pago_1a_valor || 0) : 0)
        + (c.pago_2a_prestacao ? Number(c.pago_2a_valor || 0) : 0)
      const deve = total - pago
      if (!(deve > 0.01)) continue
      let rec = 0
      for (const id of (encsDaCompra.get(String(c.id)) || [])) {
        const e = porEnc.get(id)
        if (conta(e)) rec += recebido(e)
      }
      const v = Math.max(0, Math.min(rec - pago, deve))
      if (v > 0.01) { prometido += v; linhas.push({ ref: 'Fact. ' + (c.numero_fatura || c.numero_interno || '—'), valor: v }) }
    }
    let lucroPorRealizar = 0
    for (const x of comprasPorFechar.encomendas) {
      const e = porEnc.get(String(x.id))
      if (!conta(e)) continue
      const v = Math.min(recebido(e), x.custo)
      if (v > 0.01) { prometido += v; linhas.push({ ref: x.numero, valor: v }) }
      const base = Number(e.total_sem_iva || 0) - Number(e.desconto_valor || 0)
      lucroPorRealizar += base - x.custo
    }

    let segundasPorReceber = 0
    for (const e of encomendas) {
      if (!conta(e) || !e.pago_1a_prestacao || e.pago_2a_prestacao) continue
      if (String(e.tipo_pagamento) === '100') continue
      const total = Number(e.total_final ?? e.total_com_iva ?? 0)
      segundasPorReceber += Math.max(0, total - recebido(e))
    }

    const marketplace = Number(mkt.pendente || 0) + Number(mkt.disponivel || 0) + Number(mkt.solicitado || 0)
    const ivaFacturado = ivaPorEntregar.reduce((s, q) => s + q.valor, 0) + ivaLatente.totalPorDeclarar
    const r2 = (n) => Math.round(n * 100) / 100
    return {
      banco: r2(saldoHoje),
      marketplace: r2(marketplace),
      ivaFacturado: r2(ivaFacturado),
      prometido: r2(prometido),
      linhas: linhas.sort((a, b) => b.valor - a.valor),
      teu: r2(saldoHoje + marketplace - ivaFacturado - prometido),
      segundasPorReceber: r2(segundasPorReceber),
      ivaPorFacturar: ivaLatente.totalPorFacturar,
      lucroPorRealizar: r2(lucroPorRealizar),
      stockProprio: r2(mercadoria.custo - comprasPorFechar.custoInterno),
    }
  }, [encomendas, compras, ligacoes, internos, comprasPorFechar, saldoHoje, mkt, ivaPorEntregar, ivaLatente, mercadoria.custo])

  if (loading) {
    return <div style={{ padding: 40, textAlign: 'center', color: C.textMuted, fontFamily: FONT }}>A carregar…</div>
  }

  const CORES_FONTE = { cliente: C.success, fornecedor: C.danger, iva: C.warning, manual: C.primary }


  const rotulo = { fontSize: 10.5, fontWeight: '700', color: C.textMuted, textTransform: 'uppercase', letterSpacing: '0.6px' }
  const th = { ...rotulo, padding: '9px 12px' }
  const campo = { width: '100%', padding: '6px 8px', border: `1px solid ${C.border}`, borderRadius: '3px', fontSize: '13px', boxSizing: 'border-box', fontFamily: FONT }


  return (
    <div style={{ padding: '20px 28px 60px', fontFamily: FONT, overflowY: 'auto', height: '100%' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h1 style={{ margin: 0, fontSize: '22px', fontWeight: '700', color: C.text, display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Wallet size={22} color={C.accent} /> Tesouraria
        </h1>
        <button onClick={carregar}
          style={{ height: '32px', padding: '0 12px', border: `1px solid ${C.border}`, borderRadius: '3px', background: C.surface, cursor: 'pointer', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
          <RefreshCw size={13} /> Actualizar
        </button>
      </div>
      <p style={{ margin: '4px 0 18px', fontSize: '13px', color: C.textMuted }}>
        O que entra contra o que sai, semana a semana. Responde a uma pergunta só: <strong>em que semana é que falta dinheiro.</strong>
      </p>

      {erro && (
        <div style={{ background: C.dangerSoft, border: `1px solid ${C.danger}`, borderRadius: '4px', padding: '10px 14px', marginBottom: '16px', color: C.danger, fontSize: '13px' }}>
          {erro}
        </div>
      )}

      {/* O OBJECTIVO ANTES DO SALDO, de proposito. O saldo diz onde estas; o
          objectivo diz se o mes esta a correr bem — e e essa a pergunta com que
          se abre este ecra a meio do mes. */}
      <ObjectivoLucro />

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))', gap: '12px', marginBottom: '18px' }}>
        <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: '6px', padding: '14px 16px' }}>
          <div style={{ ...rotulo, marginBottom: '8px' }}>Saldo em conta</div>
          <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
            {/* MUDAR O VALOR MUDA A DATA PARA HOJE.
                Eram dois campos independentes, e o Marco escreveu o saldo real
                de hoje deixando a data de anteontem: o ecra somou-lhe por cima
                os 369 EUR recebidos entretanto, que ja estavam la dentro. O
                numero ficou 369 acima do que ele tem na conta — a duplicacao
                exacta que este cartao existe para impedir.
                Quem escreve um saldo novo esta a dizer "e isto que tenho
                agora". A data passa a acompanhar, e continua editavel para o
                caso raro de se estar a corrigir uma fotografia antiga. */}
            <input key={`${cfg.saldoEm}:${cfg.saldo}`} type="number" step="0.01" defaultValue={cfg.saldo}
              onBlur={e => {
                const v = Number(e.target.value) || 0
                if (v === Number(cfg.saldo)) return
                const hoje = iso(new Date())
                setCfg(c => ({ ...c, saldo: v, saldoEm: hoje }))
                guardarSaldo(v, hoje)
              }}
              style={{ width: '108px', padding: '5px 7px', border: `1px solid ${C.border}`, borderRadius: '3px', fontSize: '16px', fontWeight: '700', color: C.text, textAlign: 'right', fontFamily: FONT }} />
            <span style={{ fontSize: '14px', fontWeight: '700', color: C.textMuted }}>€</span>
          </div>
          {/* A data e tao importante como o valor: e dela que a projeccao arranca. */}
          <input type="date" value={cfg.saldoEm}
            onChange={e => { setCfg(c => ({ ...c, saldoEm: e.target.value })); guardarSaldo(cfg.saldo, e.target.value) }}
            style={{ marginTop: '6px', width: '100%', padding: '4px 6px', border: `1px solid ${C.border}`, borderRadius: '3px', fontSize: '11px', color: C.textMuted, boxSizing: 'border-box', fontFamily: FONT }} />
          {/* O QUE SE MEXEU DEPOIS DA FOTOGRAFIA.
              Sem isto, um pagamento marcado ontem ficava invisivel: fora da
              projeccao (porque ja esta recebido) e fora do saldo (porque e
              posterior a data dele). Aqui aparece, e a projeccao arranca do
              numero de hoje e nao do que se escreveu ha duas semanas. */}
          {/* A IDADE DA FOTOGRAFIA. Passada uma semana, o que o sistema nao ve
              ja pesa o suficiente para valer a pena ir buscar o numero certo. */}
          {(() => {
            const dias = Math.round((Date.now() - new Date(cfg.saldoEm + 'T00:00:00').getTime()) / 86400000)
            if (!(dias > 6)) return null
            return (
              <div style={{ marginTop: '5px', fontSize: '10.5px', color: C.warning, fontWeight: '700', lineHeight: 1.4 }}>
                ⚠ Fotografia com {dias} dias — copia o saldo do banco
              </div>
            )
          })()}
          {(desdeAFotografia.entrou > 0 || desdeAFotografia.saiu > 0) ? (
            <div style={{ marginTop: '6px', paddingTop: '6px', borderTop: `1px dashed ${C.border}`, fontSize: '11px', lineHeight: 1.5 }}>
              {desdeAFotografia.entrou > 0 && (
                <div style={{ color: C.success }}>+ {fmt(desdeAFotografia.entrou)} € recebidos desde então</div>
              )}
              {desdeAFotografia.saiu > 0 && (
                <div style={{ color: C.danger }}>− {fmt(desdeAFotografia.saiu)} € pagos desde então</div>
              )}
              {/* "ESTIMADO", e nao "hoje".
                  Este numero e a fotografia mais o que o sistema CONHECE — e o
                  sistema so conhece pagamentos marcados no Financeiro. O
                  dinheiro do marketplace, o debito directo do contabilista, as
                  comissoes e as taxas do banco passaram pela conta sem ele ver,
                  e a diferenca so cresce com o tempo.
                  Chamar-lhe "hoje" prometia o saldo bancario e entregava outra
                  coisa. Um numero honesto sobre o que nao sabe vale mais do que
                  um numero certo sobre o que sabe. */}
              <div style={{ fontWeight: '800', color: C.text, marginTop: '3px', fontSize: '13px' }}>
                = {fmt(saldoHoje)} € estimado
              </div>
              {/* PROMOVER A FOTOGRAFIA — A MAO, E NAO SOZINHO.
                  A promocao automatica foi pedida e recusada, com razao: o
                  estimado so conhece o que passou pela aplicacao. Um debito
                  directo ou uma comissao do banco nunca la entram, e a
                  diferenca entre este numero e o extracto e precisamente o
                  alarme que diz que falta alguma coisa.
                  Promovido sozinho, o erro entrava na fotografia com ar de
                  facto, ficava la para sempre e somava-se ao do mes seguinte.
                  Aqui e um clique de quem foi ao banco confirmar — e e essa
                  confirmacao que da valor ao numero. */}
              {Math.abs(saldoHoje - Number(cfg.saldo)) > 0.005 && (
                <button
                  onClick={() => {
                    if (!window.confirm(
                      `Passar ${fmt(saldoHoje)} € a saldo em conta?

` +
                      `Só o faz se já confirmaste no banco que é este o valor.

` +
                      `A contagem reinicia hoje: o que se moveu até agora deixa de ser somado, ` +
                      `porque passa a estar dentro deste número.`)) return
                    const hoje = iso(new Date())
                    setCfg(c => ({ ...c, saldo: saldoHoje, saldoEm: hoje }))
                    guardarSaldo(saldoHoje, hoje)
                  }}
                  style={{ marginTop: '6px', width: '100%', padding: '5px 8px', border: `1px solid ${C.border}`, borderRadius: '3px', background: C.surfaceAlt, color: C.text, cursor: 'pointer', fontSize: '10.5px', fontWeight: '700', fontFamily: FONT }}>
                  Usar como saldo em conta
                </button>
              )}
            </div>
          ) : (
            <div style={{ fontSize: '10px', color: C.textFaint, marginTop: '4px' }}>
              {guardandoSaldo ? 'a guardar…' : 'a projecção arranca nesta data'}
            </div>
          )}
          <div style={{ fontSize: '10px', color: C.textFaint, marginTop: '5px', lineHeight: 1.45 }}>
            <strong>Saldo em conta</strong> é o que viste no banco naquela data — não é calculado.
            O <strong>estimado</strong> é essa fotografia mais o que a aplicação conhece:
            encomendas, compras e movimentos manuais.
            <br />
            Débitos directos, comissões e marketplace passam pelo banco sem o sistema ver.
            Por isso a diferença entre o estimado e o extracto <strong>é o aviso de que falta
            alguma coisa</strong> — e é por isso que o saldo não se actualiza sozinho.
            Confirma no banco e carrega em “usar como saldo em conta”.
            <br />
            Uma despesa que já saiu e o sistema não podia adivinhar — um jantar, um negócio
            fechado numa reunião — lança-se em <strong>Movimentos manuais</strong> com a data
            de hoje: desconta já do estimado.
          </div>
        </div>

        <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: '6px', padding: '14px 16px' }}>
          <div style={rotulo}>A receber</div>
          <div style={{ fontSize: '21px', fontWeight: '800', color: C.success, marginTop: '6px' }}>{fmt(totais.receber)} €</div>
          <div style={{ fontSize: '11px', color: C.textMuted, marginTop: '2px' }}>nas próximas {SEMANAS} semanas</div>
        </div>

        <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: '6px', padding: '14px 16px' }}>
          <div style={rotulo}>A pagar</div>
          <div style={{ fontSize: '21px', fontWeight: '800', color: C.danger, marginTop: '6px' }}>{fmt(totais.pagar)} €</div>
          {/* A legenda diz o que ESTA ali dentro, e nao o que costuma estar. O
              IVA vence-se 55 dias depois do trimestre e cai fora da janela na
              maior parte do ano — prometer "IVA" num numero que nao o tem e uma
              mentira pequena que estraga a confianca no resto do ecra. */}
          <div style={{ fontSize: '11px', color: C.textMuted, marginTop: '2px' }}>
            {[
              movimentos.some(m => m.fonte === 'fornecedor') && 'fornecedores',
              movimentos.some(m => m.fonte === 'iva') && 'IVA',
              movimentos.some(m => m.fonte === 'manual') && 'despesas',
            ].filter(Boolean).join(', ') || 'nada agendado'}
          </div>
        </div>

        {/* O IVA nao e uma despesa como as outras: ja esta na conta e nao e
            nosso. Merece um cartao proprio, e nao uma linha no meio do resto. */}
        {totais.ivaTotal > 0 && (
          <div style={{ background: '#fff8e1', border: `1px solid ${C.warning}66`, borderRadius: '6px', padding: '14px 16px' }}>
            <div style={{ ...rotulo, color: '#92400e' }}>Do saldo, é do Estado</div>
            <div style={{ fontSize: '21px', fontWeight: '800', color: C.warning, marginTop: '6px' }}>{fmt(totais.ivaTotal)} €</div>
            <div style={{ fontSize: '11px', color: C.textMuted, marginTop: '2px', lineHeight: 1.5 }}>
              {/* AS TRES LINHAS SEPARADAS, e nao um "latente" que junta duas
                  coisas. O cartao dizia "por facturar" num numero que ja incluia
                  as facturadas por declarar: ao emitir uma factura, o valor
                  ficava igual e parecia que nada tinha acontecido. Um ecra que
                  nao mostra o efeito de uma accao ensina a desconfiar dele. */}
              {fmt(totais.ivaFacturado)} € facturado
              {ivaLatente.totalPorFacturar > 0 && <>
                <br /><strong style={{ color: '#92400e' }}>{fmt(ivaLatente.totalPorFacturar)} € por facturar</strong>
              </>}
              {ivaLatente.totalPorDeclarar > 0 && <>
                <br /><span style={{ color: '#92400e' }}>{fmt(ivaLatente.totalPorDeclarar)} € facturado, por declarar</span>
              </>}
            </div>
          </div>
        )}

        {/* O numero que conta e o `teu`, e nao a posicao bruta: essa inclui IVA
            que ainda nao foi descontado por vencer fora da janela. */}
        <div style={{ background: totais.teu >= 0 ? C.successSoft : C.dangerSoft, border: `1px solid ${totais.teu >= 0 ? C.success : C.danger}`, borderRadius: '6px', padding: '14px 16px' }}>
          <div style={{ ...rotulo, color: totais.teu >= 0 ? C.success : C.danger }}>Realmente teu</div>
          <div style={{ fontSize: '21px', fontWeight: '800', color: totais.teu >= 0 ? C.success : C.danger, marginTop: '6px' }}>{fmt(totais.teu)} €</div>
          <div style={{ fontSize: '11px', color: C.textMuted, marginTop: '2px' }}>
            {fmt(totais.liquida)} € no fim
            {totais.ivaPorDescontar > 0 && <> − {fmt(totais.ivaPorDescontar)} € de IVA</>}
          </div>
        </div>
      </div>

      {/* TEU HOJE — o unico numero deste ecra que e de hoje e nao a treze
          semanas. Ver o comentario no calculo. */}
      <div style={{ background: '#eef4ff', border: `1px solid ${C.primary}55`, borderRadius: '6px', padding: '12px 16px', marginBottom: '18px' }}>
        <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: '12px', flexWrap: 'wrap' }}>
          <div>
            <strong style={{ fontSize: '13px', color: C.text }}>Teu hoje</strong>
            <div style={{ fontSize: '11px', color: C.textMuted }}>o que está na conta e não está prometido a ninguém · {new Date().toLocaleDateString('pt-PT')}</div>
          </div>
          <span style={{ fontSize: '24px', fontWeight: '800', color: teuHoje.teu >= 0 ? C.success : C.danger }}>{fmt(teuHoje.teu)} €</span>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))', gap: '4px 18px', marginTop: '8px', fontSize: '12px', color: C.text }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}><span>Banco hoje</span><strong>{fmt(teuHoje.banco)} €</strong></div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}><span>+ Marketplace por receber</span><strong>{fmt(teuHoje.marketplace)} €</strong></div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}><span>− IVA já facturado</span><strong style={{ color: C.warning }}>{fmt(teuHoje.ivaFacturado)} €</strong></div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }} title={teuHoje.linhas.map(l => l.ref + ': ' + fmt(l.valor) + ' €').join(String.fromCharCode(10))}>
            <span>− Dos clientes, ainda a ir para o fornecedor ({teuHoje.linhas.length})</span><strong style={{ color: C.warning }}>{fmt(teuHoje.prometido)} €</strong>
          </div>
        </div>
        <div style={{ marginTop: '8px', fontSize: '11px', color: C.textMuted, lineHeight: 1.5 }}>
          A caminho, fora desta conta: <strong>{fmt(teuHoje.segundasPorReceber)} €</strong> de 2.ªs prestações por receber ·
          {' '}<strong>{fmt(teuHoje.ivaPorFacturar)} €</strong> de IVA de encomendas por facturar ·
          {' '}<strong>{fmt(teuHoje.lucroPorRealizar)} €</strong> de lucro nas encomendas por comprar ·
          {' '}<strong>{fmt(teuHoje.stockProprio)} €</strong> em stock próprio, ao custo.
        </div>
      </div>

      {/* COMPRAS POR FECHAR — o custo que ainda nao entrou.
          A receita da encomenda entra ja; o custo so quando a compra for
          lancada. Entre os dois momentos o ecra mostra mais dinheiro do que
          existe, e este quadro diz de quanto. */}
      {comprasPorFechar.custo > 0 && (
        <div style={{ background: '#fff8e1', border: `1px solid ${C.warning}66`, borderRadius: '6px', padding: '12px 16px', marginBottom: '18px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
            <AlertTriangle size={15} color={C.warning} />
            <strong style={{ fontSize: '13px', color: '#92400e' }}>
              {fmt(comprasPorFechar.custo)} € de mercadoria por comprar ao fornecedor
            </strong>
          </div>
          <div style={{ fontSize: '11.5px', color: C.textMuted, lineHeight: 1.5, marginBottom: '7px' }}>
            {comprasPorFechar.encomendas.length} encomenda{comprasPorFechar.encomendas.length === 1 ? '' : 's'} sinalizada{comprasPorFechar.encomendas.length === 1 ? '' : 's'} sem compra lançada.
            A receita delas já está contada acima; <strong>o custo ainda não</strong>.
            Descontando-o, o que é realmente teu fica em{' '}
            <strong style={{ color: C.text }}>{fmt(totais.teu - comprasPorFechar.custo)} €</strong>.
            Assim que fechares o pedido e lançares a factura, sai daqui.
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
            {comprasPorFechar.encomendas.slice(0, 8).map(e => (
              <div key={e.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '12px' }}>
                <span style={{ fontWeight: '600', color: C.text, minWidth: '78px' }}>{e.numero}</span>
                <span style={{ flex: 1, color: C.textMuted, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.cliente}</span>
                <span style={{ color: C.textFaint, whiteSpace: 'nowrap' }}>{new Date(e.data).toLocaleDateString('pt-PT')}</span>
                <span style={{ fontWeight: '700', color: C.warning, minWidth: '86px', textAlign: 'right' }}>{fmt(e.custo)} €</span>
              </div>
            ))}
            {comprasPorFechar.encomendas.length > 8 && (
              <div style={{ fontSize: '11px', color: C.textMuted }}>e mais {comprasPorFechar.encomendas.length - 8}</div>
            )}
          </div>
        </div>
      )}

      {/* O EQUILIBRIO — a politica do Marco, com numero.
          Metade em dinheiro, metade em mercadoria. Nao e uma regra contabil; e
          a defesa contra as duas maneiras de dar cabo disto: dinheiro parado
          que nao trabalha, ou lucro do B2B todo encravado em prateleira sem
          poder pagar nada. */}
      {equilibrio && (
        <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: '6px', padding: '12px 16px', marginBottom: '18px' }}>
          <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px', marginBottom: '9px' }}>
            <div style={{ ...rotulo }}>Equilíbrio da empresa</div>
            <div style={{ fontSize: '12px', color: C.textMuted }}>
              objectivo <strong style={{ color: C.text }}>50 / 50</strong>
            </div>
          </div>

          {/* A barra e a leitura mais rapida que ha: ve-se de longe se esta
              torta, sem ler numero nenhum. */}
          <div style={{ display: 'flex', height: '26px', borderRadius: '4px', overflow: 'hidden', border: `1px solid ${C.border}` }}>
            <div style={{ width: equilibrio.pctLiquido + '%', background: C.success, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '11.5px', fontWeight: '800', minWidth: 0 }}>
              {equilibrio.pctLiquido >= 12 && (equilibrio.pctLiquido + '%')}
            </div>
            <div style={{ width: equilibrio.pctStock + '%', background: C.purple || C.primary, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '11.5px', fontWeight: '800', minWidth: 0 }}>
              {equilibrio.pctStock >= 12 && (equilibrio.pctStock + '%')}
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '7px', fontSize: '12px', flexWrap: 'wrap', gap: '8px' }}>
            <div>
              <span style={{ color: C.success, fontWeight: '800' }}>{fmt(equilibrio.liquido)} €</span>
              <span style={{ color: C.textMuted }}> líquido — conta e a receber</span>
            </div>
            <div>
              <span style={{ color: C.purple || C.primary, fontWeight: '800' }}>{fmt(equilibrio.stock)} €</span>
              <span style={{ color: C.textMuted }}> em mercadoria, já paga</span>
            </div>
          </div>

          {/* O aviso so aparece quando ha decisao a tomar. Entre 35 e 65 nao ha
              nada a fazer, e um aviso permanente deixa de ser lido. */}
          {(() => {
            const p = equilibrio.pctStock
            if (p > 65) return (
              <div style={{ marginTop: '9px', paddingTop: '8px', borderTop: `1px dashed ${C.border}`, fontSize: '11.5px', color: C.warning, fontWeight: '600', lineHeight: 1.5 }}>
                ⚠ {p}% em mercadoria — está a encravar lucro do B2B em prateleira.
                <span style={{ color: C.textMuted, fontWeight: '400' }}>
                  {' '}Antes de comprares mais, vende. Foi assim que o concorrente alemão ficou com 120 unidades a vender ao custo.
                </span>
              </div>
            )
            if (p < 35) return (
              <div style={{ marginTop: '9px', paddingTop: '8px', borderTop: `1px dashed ${C.border}`, fontSize: '11.5px', color: C.warning, fontWeight: '600', lineHeight: 1.5 }}>
                ⚠ só {p}% em mercadoria — tens dinheiro parado que não está a trabalhar.
                <span style={{ color: C.textMuted, fontWeight: '400' }}>
                  {' '}Cabe-te comprar até aos 50%: <strong style={{ color: C.text }}>{fmt(Math.round((equilibrio.total / 2 - equilibrio.stock) * 100) / 100)} €</strong> de mercadoria.
                </span>
              </div>
            )
            return (
              <div style={{ marginTop: '9px', paddingTop: '8px', borderTop: `1px dashed ${C.border}`, fontSize: '11.5px', color: C.textMuted, lineHeight: 1.5 }}>
                ✓ Equilibrado. Até aos 50% ainda cabem{' '}
                <strong style={{ color: C.text }}>{fmt(Math.max(0, Math.round((equilibrio.total / 2 - equilibrio.stock) * 100) / 100))} €</strong> de mercadoria —
                é esse o tecto da próxima encomenda se quiseres manter a política.
              </div>
            )
          })()}

          <div style={{ fontSize: '10px', color: C.textFaint, marginTop: '7px', lineHeight: 1.45 }}>
            <strong>Líquido</strong> é o que é teu em dinheiro depois do IVA e do custo das encomendas por comprar,
            mais o que o marketplace ainda deve.
            <strong> Mercadoria</strong> é o stock ao custo, menos as unidades que ainda não pagaste —
            tens o frasco mas o capital nele ainda não é teu.
          </div>
        </div>
      )}

      {/* MERCADORIA — AO LADO, NUNCA SOMADA.
          Somar 3.780 EUR de perfumes ao saldo fazia o ecra mentir da maneira
          exacta que o cartao "Realmente teu" existe para impedir: uma semana
          negativa continua negativa, haja ou nao stock no armazem. Sao duas
          verdades diferentes e ficam em sitios diferentes. */}
      {(mercadoria.custo > 0 || mediaMarketplace) && (
        <div style={{ background: C.surfaceAlt, border: `1px solid ${C.border}`, borderRadius: '6px', padding: '12px 16px', marginBottom: '18px', display: 'flex', flexWrap: 'wrap', gap: '20px', alignItems: 'center' }}>
          {mercadoria.custo > 0 && (
            <div>
              <div style={{ ...rotulo, marginBottom: '3px' }}>Em mercadoria</div>
              <div style={{ fontSize: '17px', fontWeight: '800', color: C.purple || C.primary }}>{fmt(mercadoria.custo)} €</div>
              <div style={{ fontSize: '11px', color: C.textMuted, marginTop: '1px' }}>
                {mercadoria.unidades} un ao custo
                {mercadoria.emTransito > 0 && <>, das quais {mercadoria.emTransito} a caminho</>}
              </div>
            </div>
          )}
          <div style={{ flex: 1, minWidth: '260px', fontSize: '11.5px', color: C.textMuted, lineHeight: 1.55 }}>
            Isto <strong>não entra</strong> na projecção — mercadoria não paga o contabilista em Outubro.
            É lucro do B2B reinvestido em artigos, e vira dinheiro quando sair no marketplace.
            {/* UM SO RITMO, E O MELHOR QUE HOUVER.
                O `mediaMarketplace` conta o que foi lancado, e o que se lanca
                chega vinte dias depois de acontecer. O `ritmoMkt` mede pela
                variacao do saldo e sabe hoje. Mostrar os dois era pôr no mesmo
                ecra duas respostas diferentes para a mesma pergunta — e quem
                olha nao tem como saber qual delas usar. */}
            {ritmoMkt?.porMes != null ? <>
              {' '}Ritmo medido pelo saldo do marketplace: <strong style={{ color: C.text }}>{fmt(ritmoMkt.porMes)} €/mês</strong> c/IVA.
            </> : mediaMarketplace ? <>
              {' '}Ritmo dos últimos 3 meses, pelo que foi lançado: <strong style={{ color: C.text }}>{fmt(mediaMarketplace)} €/mês</strong> s/IVA.
            </> : null}
            {' '}Lança a venda na Previsão <strong>quando o dinheiro entrar</strong>; até lá vive no saldo do marketplace, aqui em baixo.
          </div>
        </div>
      )}

      {/* NO MARKETPLACE — o que eles ainda devem, e que nao estava em lado nenhum.
          FORA DA PROJECCAO, de proposito e de acordo com o Marco. O valor
          sabe-se; a data em que cada parcela sai da cativacao e que nao. Meter
          uma data inventada numa semana estragava o unico numero deste ecra que
          responde a pergunta que ele existe para responder. Fica ao lado, como
          a mercadoria, e soma-se de cabeca quando se quer a fotografia toda. */}
      <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: '6px', padding: '12px 16px', marginBottom: '18px' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '18px', alignItems: 'flex-start' }}>
          <div style={{ minWidth: '150px' }}>
            <div style={{ ...rotulo, marginBottom: '3px' }}>No marketplace</div>
            <div style={{ fontSize: '19px', fontWeight: '800', color: C.primary }}>{fmt(mktTotal)} €</div>
            <div style={{ fontSize: '10.5px', color: C.textFaint, marginTop: '2px' }}>
              {mkt.em ? 'copiado a ' + new Date(mkt.em + 'T00:00:00').toLocaleDateString('pt-PT') : 'ainda não copiaste nada'}
              {guardandoMkt && ' · a guardar…'}
            </div>
            {/* TRES DIAS, e nao os sete do banco: ha vendas quase todos os dias,
                portanto uma fotografia de quinta-feira ja nao serve na segunda. */}
            {(() => {
              if (!mkt.em) return null
              const dias = Math.round((Date.now() - new Date(mkt.em + 'T00:00:00').getTime()) / 86400000)
              if (!(dias > 3)) return null
              return (
                <div style={{ marginTop: '5px', fontSize: '10.5px', color: C.warning, fontWeight: '700', lineHeight: 1.4 }}>
                  ⚠ Fotografia com {dias} dias — vai copiar outra vez
                </div>
              )
            })()}
          </div>

          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            {[
              ['pendente', 'Pendente', 'aguarda cativação'],
              ['disponivel', 'Disponível', 'pronto a pedir'],
              ['solicitado', 'Solicitado', 'já pedido'],
            ].map(([campo, titulo, nota]) => (
              <div key={campo}>
                <div style={{ ...rotulo, fontSize: 9.5, marginBottom: '3px' }}>{titulo}</div>
                <input key={`${campo}:${mkt.em}:${mkt[campo]}`} type="number" step="0.01" defaultValue={mkt[campo]}
                  onBlur={e => {
                    const v = Math.round((Number(e.target.value) || 0) * 100) / 100
                    if (v === Number(mkt[campo])) return
                    alterarMkt(campo, v)
                  }}
                  style={{ width: '92px', padding: '4px 6px', border: `1px solid ${C.border}`, borderRadius: '3px', fontSize: '13px', fontWeight: '700', color: C.text, textAlign: 'right', fontFamily: FONT }} />
                <div style={{ fontSize: '9.5px', color: C.textFaint, marginTop: '2px' }}>{nota}</div>
              </div>
            ))}
          </div>
        </div>

        {/* O QUE AINDA NAO ESTA CONTADO EM LADO NENHUM.
            As vendas ja lancadas e por receber vivem nos dois sitios ao mesmo
            tempo: dentro deste saldo, porque o marketplace ainda as tem, e
            dentro da projeccao, porque ja foram lancadas. Descontam-se, e o que
            sobra e o que os numeros do ecra estao mesmo a menos. */}
        {mktTotal > 0 && (
          <div style={{ marginTop: '10px', paddingTop: '9px', borderTop: `1px dashed ${C.border}`, fontSize: '11.5px', lineHeight: 1.55, color: C.textMuted }}>
            {mktPorReceber > 0.005 && (
              <>Já lançaste na Previsão <strong style={{ color: C.text }}>{fmt(mktPorReceber)} €</strong> destes,
              por receber. Descontando-os, </>
            )}
            {naoContado > 0.005 ? (
              <>há <strong style={{ color: C.success }}>{fmt(naoContado)} €</strong> que ainda não estão contados em lado nenhum
              {' '}— nem no saldo, nem na projecção, nem no “realmente teu”.</>
            ) : naoContado < -0.005 ? (
              <span style={{ color: C.warning, fontWeight: '600' }}>
                lançaste {fmt(-naoContado)} € a mais do que o marketplace tem. Ou a fotografia está velha,
                ou há uma venda lançada que já recebeste e ficou por marcar.
              </span>
            ) : (
              <>está tudo lançado — o saldo do marketplace e o que tens na Previsão dizem o mesmo.</>
            )}
          </div>
        )}

        {/* O RITMO, MEDIDO PELO SALDO E NAO PELO QUE FOI LANCADO.
            Diz-se de que e feito — variacao e levantamentos — porque um numero
            que aparece sozinho nao deixa ninguem perceber que esta errado. */}
        <div style={{ marginTop: '10px', paddingTop: '9px', borderTop: `1px dashed ${C.border}` }}>
          {ritmoMkt ? (
            <>
              <div style={{ fontSize: '12.5px', color: C.text, lineHeight: 1.5 }}>
                Vendeste <strong style={{ color: C.primary }}>{fmt(ritmoMkt.vendido)} €</strong> c/IVA
                {' '}nos últimos {ritmoMkt.dias} dia{ritmoMkt.dias === 1 ? '' : 's'}
                {ritmoMkt.porMes != null && <> — ritmo de <strong style={{ color: C.primary }}>{fmt(ritmoMkt.porMes)} €/mês</strong></>}.
              </div>
              <div style={{ fontSize: '10.5px', color: C.textFaint, marginTop: '4px', lineHeight: 1.5 }}>
                Saldo {ritmoMkt.variacao >= 0 ? 'subiu' : 'desceu'} {fmt(Math.abs(ritmoMkt.variacao))} €
                {ritmoMkt.levantado > 0.005 && <>, e levantaste {fmt(ritmoMkt.levantado)} €</>}
                {' '}entre {new Date(ritmoMkt.de + 'T00:00:00').toLocaleDateString('pt-PT')} e {new Date(ritmoMkt.ate + 'T00:00:00').toLocaleDateString('pt-PT')}
                {' '}· {ritmoMkt.fotografias} fotografias.
                {ritmoMkt.levantamentos > 0
                  ? ' Depende de ' + ritmoMkt.levantamentos + ' recebimento' + (ritmoMkt.levantamentos === 1 ? '' : 's') + ' lançado' + (ritmoMkt.levantamentos === 1 ? '' : 's') + ': se algum ficou por marcar, este número fica abaixo do real.'
                  : ' Sem levantamentos no período.'}
              </div>
              {lucroUnidade && (
                <div style={{ fontSize: '12.5px', color: C.text, lineHeight: 1.5, marginTop: '5px' }}>
                  Lucro de <strong style={{ color: C.success }}>{fmt(lucroUnidade.porUnidade)} € por unidade</strong>
                  {' '}— {lucroUnidade.unidades} un vendidas, {fmt(lucroUnidade.receita)} € s/IVA
                  {' '}menos {fmt(lucroUnidade.custo)} € de custo.
                  {lucroUnidade.unidadesSemCusto > 0 && (
                    <span style={{ color: C.warning, fontWeight: '600' }}>
                      {' '}⚠ {lucroUnidade.unidadesSemCusto} un sem preço de custo — o lucro está acima do real.
                    </span>
                  )}
                </div>
              )}
            </>
          ) : (
            <div style={{ fontSize: '10.5px', color: C.textFaint, lineHeight: 1.5 }}>
              Para medir o ritmo preciso de <strong>duas fotografias em dias diferentes</strong>.
              Cola outra vez amanhã e a partir daí a facturação B2C passa a sair por diferença,
              sem esperar pelos recebimentos.
            </div>
          )}
        </div>

        {/* COLAR EM VEZ DE ESCREVER. Tres numeros a mao todos os dias faz-se mal
            ao terceiro dia. O que se le MOSTRA-SE ANTES DE GRAVAR: um leitor que
            grava sozinho um numero mal lido e pior do que nao haver leitor. */}
        <div style={{ marginTop: '10px', paddingTop: '9px', borderTop: `1px dashed ${C.border}` }}>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
            <textarea
              value={colagem?.texto || ''}
              onChange={e => setColagem({ texto: e.target.value, lido: null })}
              placeholder="Selecciona os cartões no painel do marketplace, copia, e cola aqui"
              rows={2}
              style={{ flex: 1, minWidth: '220px', padding: '6px 8px', border: `1px solid ${C.border}`, borderRadius: '3px', fontSize: '11.5px', fontFamily: FONT, color: C.text, resize: 'vertical', boxSizing: 'border-box' }} />
            <button
              disabled={!(colagem?.texto || '').trim()}
              onClick={() => setColagem(c => ({ texto: c?.texto || '', lido: parseSaldoMarketplace(c?.texto || '') }))}
              style={{ padding: '7px 14px', border: `1px solid ${C.border}`, borderRadius: '3px', background: (colagem?.texto || '').trim() ? C.surfaceAlt : C.surface, color: (colagem?.texto || '').trim() ? C.text : C.textFaint, cursor: (colagem?.texto || '').trim() ? 'pointer' : 'default', fontSize: '12px', fontWeight: '700', fontFamily: FONT, whiteSpace: 'nowrap' }}>
              Ler
            </button>
          </div>

          {colagem?.lido && (
            <div style={{ marginTop: '8px', padding: '9px 11px', background: C.surfaceAlt, border: `1px solid ${C.border}`, borderRadius: '4px' }}>
              {colagem.lido.ok && (
                <div style={{ fontSize: '12px', color: C.text, fontWeight: '600' }}>
                  Li: pendente <strong>{fmt(colagem.lido.pendente)} €</strong> ·
                  {' '}disponível <strong>{fmt(colagem.lido.disponivel)} €</strong> ·
                  {' '}solicitado <strong>{fmt(colagem.lido.solicitado)} €</strong> ·
                  {' '}total <strong>{fmt(colagem.lido.total)} €</strong>
                </div>
              )}
              {colagem.lido.avisos.map((a, i) => (
                <div key={i} style={{ fontSize: '11px', color: C.warning, fontWeight: '600', marginTop: '4px', lineHeight: 1.45 }}>⚠ {a}</div>
              ))}
              <div style={{ display: 'flex', gap: '7px', marginTop: '8px' }}>
                {colagem.lido.ok && (
                  <button
                    onClick={() => {
                      const novo = {
                        pendente: colagem.lido.pendente,
                        disponivel: colagem.lido.disponivel,
                        solicitado: colagem.lido.solicitado,
                        em: iso(new Date()),
                      }
                      setMkt(novo)
                      guardarMarketplace(novo)
                      setColagem(null)
                    }}
                    style={{ padding: '5px 12px', border: 'none', borderRadius: '3px', background: C.success, color: '#fff', cursor: 'pointer', fontSize: '11.5px', fontWeight: '700', fontFamily: FONT, display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <Save size={12} /> Gravar
                  </button>
                )}
                <button onClick={() => setColagem(null)}
                  style={{ padding: '5px 12px', border: `1px solid ${C.border}`, borderRadius: '3px', background: C.surface, color: C.textMuted, cursor: 'pointer', fontSize: '11.5px', fontFamily: FONT }}>
                  Cancelar
                </button>
              </div>
            </div>
          )}
        </div>

        <div style={{ fontSize: '10px', color: C.textFaint, marginTop: '8px', lineHeight: 1.45 }}>
          Isto <strong>não entra</strong> na projecção nem no “realmente teu” — a data em que cada
          parcela sai da cativação não se sabe, e uma data inventada estragava o quadro das semanas.
          <br />
          A partir de agora lança na Previsão <strong>só quando o dinheiro entrar</strong>, com o visto
          de recebido. O que está por receber vive aqui, e mais lado nenhum — é assim que não conta a dobrar.
        </div>
      </div>

      {/* O aviso que este ecra existe para dar. */}
      {totais.primeiraNegativa && (
        <div style={{ background: C.dangerSoft, border: `2px solid ${C.danger}`, borderRadius: '6px', padding: '12px 16px', marginBottom: '18px', display: 'flex', alignItems: 'center', gap: '12px' }}>
          <AlertTriangle size={22} color={C.danger} style={{ flexShrink: 0 }} />
          <div style={{ fontSize: '13.5px', color: C.text, lineHeight: 1.5 }}>
            A conta fica negativa na semana de <strong>{dataCurta(totais.primeiraNegativa.de)}</strong> — previsão de{' '}
            <strong style={{ color: C.danger }}>{fmt(totais.primeiraNegativa.saldo)} €</strong>.
          </div>
        </div>
      )}

      {atrasados.length > 0 && (
        <div style={{ background: '#fff8e1', border: `1px solid ${C.warning}66`, borderRadius: '6px', padding: '12px 16px', marginBottom: '18px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
            <Clock size={15} color={C.warning} />
            <strong style={{ fontSize: '13px', color: '#92400e' }}>
              Já devia ter acontecido — {fmt(totais.atrasadoEntrada)} € a receber, {fmt(totais.atrasadoSaida)} € a pagar
            </strong>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
            {atrasados.slice(0, 14).map((m, i) => (
              <span key={i} title={`${m.detalhe} · ${dataCurta(m.data)}`}
                style={{ fontSize: '11px', padding: '3px 8px', borderRadius: '10px', background: C.surface, border: `1px solid ${C.border}`, color: m.tipo === 'entrada' ? C.success : C.danger }}>
                {m.titulo} · {fmt(m.valor)} €
              </span>
            ))}
            {atrasados.length > 14 && (
              <span style={{ fontSize: '11px', color: C.textMuted, padding: '3px 4px' }}>e mais {atrasados.length - 14}</span>
            )}
          </div>
        </div>
      )}

      <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: '6px', overflow: 'hidden', marginBottom: '22px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
          <thead>
            <tr style={{ background: C.surfaceAlt }}>
              <th style={{ ...th, textAlign: 'left' }}>Semana</th>
              <th style={{ ...th, textAlign: 'right' }}>Entra</th>
              <th style={{ ...th, textAlign: 'right' }}>Sai</th>
              <th style={{ ...th, textAlign: 'right' }}>Movimento</th>
              <th style={{ ...th, textAlign: 'right' }}>Saldo</th>
            </tr>
          </thead>
          <tbody>
            {semanas.map(s => {
              const negativo = s.saldo < 0
              const aberta = semanaAberta === s.i
              return (
                <React.Fragment key={s.i}>
                  <tr onClick={() => setSemanaAberta(aberta ? null : s.i)}
                    style={{ cursor: 'pointer',
                      // As semanas depois da fronteira ficam mais apagadas: nao
                      // sao menos verdadeiras, sao menos completas.
                      opacity: (ultimaSemanaFirme >= 0 && s.i > ultimaSemanaFirme) ? 0.62 : 1,
                      background: negativo ? C.dangerSoft : (s.i % 2 ? C.surfaceAlt : C.surface), borderTop: `1px solid ${C.border}` }}>
                    <td style={{ padding: '9px 12px', fontWeight: '600', color: C.text }}>
                      {dataCurta(s.de)} – {dataCurta(s.ate)}
                      {s.itens.length > 0 && <span style={{ marginLeft: '6px', fontSize: '10.5px', color: C.textFaint }}>({s.itens.length})</span>}
                    </td>
                    <td style={{ padding: '9px 12px', textAlign: 'right', color: s.entra > 0 ? C.success : C.textFaint }}>{s.entra > 0 ? fmt(s.entra) : '—'}</td>
                    <td style={{ padding: '9px 12px', textAlign: 'right', color: s.sai > 0 ? C.danger : C.textFaint }}>{s.sai > 0 ? fmt(s.sai) : '—'}</td>
                    <td style={{ padding: '9px 12px', textAlign: 'right', fontWeight: '600', color: s.movimento >= 0 ? C.success : C.danger }}>
                      {s.movimento >= 0 ? '+' : ''}{fmt(s.movimento)}
                    </td>
                    <td style={{ padding: '9px 12px', textAlign: 'right', fontWeight: '800', color: negativo ? C.danger : C.text }}>{fmt(s.saldo)} €</td>
                  </tr>
                  {/* A fronteira entre o comprometido e o que falta acontecer. */}
                  {s.i === ultimaSemanaFirme && ultimaSemanaFirme < SEMANAS - 1 && (
                    <tr>
                      <td colSpan={5} style={{ padding: '7px 12px', background: C.surfaceAlt, borderTop: `2px solid ${C.border}`, borderBottom: `1px solid ${C.border}` }}>
                        <span style={{ fontSize: '11px', color: C.textMuted, display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <Info size={12} style={{ flexShrink: 0 }} />
                          Daqui em diante só aparece o que já está agendado — as encomendas destes meses ainda não existem.
                        </span>
                      </td>
                    </tr>
                  )}
                  {aberta && s.itens.map((m, j) => (
                    <tr key={`${s.i}-${j}`} style={{ background: C.bg, fontSize: '12px' }}>
                      <td style={{ padding: '6px 12px 6px 28px', color: C.text }} colSpan={2}>
                        <span style={{ display: 'inline-block', width: '7px', height: '7px', borderRadius: '50%', background: CORES_FONTE[m.fonte] || C.textMuted, marginRight: '7px' }} />
                        {m.titulo}
                        {!m.certo && <span title="Valor previsto — pode mudar quando chegar a factura final" style={{ marginLeft: '6px', fontSize: '10px', color: C.warning }}>≈</span>}
                      </td>
                      <td style={{ padding: '6px 12px', color: C.textMuted }}>{m.detalhe}</td>
                      <td style={{ padding: '6px 12px', textAlign: 'right', color: C.textMuted }}>{dataCurta(m.data)}</td>
                      <td style={{ padding: '6px 12px', textAlign: 'right', fontWeight: '600', color: m.tipo === 'entrada' ? C.success : C.danger }}>
                        {m.tipo === 'entrada' ? '+' : '−'}{fmt(m.valor)}
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              )
            })}
          </tbody>
        </table>
      </div>

      {/* AS FACTURAS POR TIRAR.
          Nao e so uma conta de IVA: uma encomenda entregue ha dois meses sem
          factura passa a estar a vista, ordenada pela mais antiga. */}
      {(ivaLatente.porFacturar.length > 0 || ivaLatente.porDeclarar.length > 0) && (
        <div style={{ background: '#fffbeb', border: `1px solid ${C.warning}66`, borderRadius: '6px', padding: '12px 16px', marginBottom: '22px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
            <AlertTriangle size={15} color={C.warning} />
            <strong style={{ fontSize: '13px', color: '#92400e' }}>IVA que ainda não está declarado</strong>
          </div>

          {ivaLatente.porFacturar.length > 0 && (
            <>
              <div style={{ fontSize: '11.5px', color: C.textMuted, marginBottom: '5px' }}>
                <strong style={{ color: C.text }}>{ivaLatente.porFacturar.length} encomenda{ivaLatente.porFacturar.length === 1 ? '' : 's'} por facturar</strong>
                {' '}— {fmt(ivaLatente.totalPorFacturar)} € de IVA. Assim que tirares a factura, sai daqui sozinha.
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '3px', marginBottom: '10px' }}>
                {ivaLatente.porFacturar.slice(0, 10).map(x => (
                  <div key={x.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '12.5px' }}>
                    <span style={{ fontWeight: '600', color: C.text, minWidth: '78px' }}>{x.numero}</span>
                    <span style={{ flex: 1, color: C.textMuted, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{x.cliente}</span>
                    <span style={{ color: C.textFaint, whiteSpace: 'nowrap' }}>{new Date(x.data).toLocaleDateString('pt-PT')}</span>
                    <span style={{ fontWeight: '700', color: C.warning, minWidth: '80px', textAlign: 'right' }}>{fmt(x.iva)} €</span>
                  </div>
                ))}
                {ivaLatente.porFacturar.length > 10 && (
                  <div style={{ fontSize: '11px', color: C.textMuted }}>e mais {ivaLatente.porFacturar.length - 10}</div>
                )}
              </div>
            </>
          )}

          {ivaLatente.porDeclarar.length > 0 && (
            <div style={{ fontSize: '11.5px', color: C.textMuted, borderTop: `1px dashed ${C.warning}44`, paddingTop: '8px' }}>
              <strong style={{ color: C.text }}>
                {ivaLatente.porDeclarar.length} factura{ivaLatente.porDeclarar.length === 1 ? '' : 's'} fora da declaração
              </strong>
              {' '}— {fmt(ivaLatente.totalPorDeclarar)} € de IVA. Reimporta o mapa de vendas desse mês e saem daqui.
              <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', marginTop: '5px' }}>
                {ivaLatente.porDeclarar.slice(0, 10).map(x => (
                  <div key={x.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '12px' }}>
                    <span style={{ fontWeight: '600', color: C.text, minWidth: '78px' }}>{x.numero}</span>
                    <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {x.cliente} · {x.motivo}
                    </span>
                    <span style={{ color: C.textFaint, whiteSpace: 'nowrap' }}>{new Date(x.data).toLocaleDateString('pt-PT')}</span>
                    <span style={{ fontWeight: '700', color: C.warning, minWidth: '76px', textAlign: 'right' }}>{fmt(x.iva)} €</span>
                  </div>
                ))}
                {ivaLatente.porDeclarar.length > 10 && (
                  <div style={{ fontSize: '11px', color: C.textMuted }}>e mais {ivaLatente.porDeclarar.length - 10}</div>
                )}
              </div>
            </div>
          )}
        </div>
      )}

      {/* O que espreita logo a seguir a janela. O IVA vive quase sempre aqui. */}
      {depois.length > 0 && (
        <div style={{ background: C.surfaceAlt, border: `1px solid ${C.border}`, borderRadius: '6px', padding: '12px 16px', marginBottom: '22px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
            <Info size={15} color={C.textMuted} />
            <strong style={{ fontSize: '13px', color: C.text }}>A seguir às {SEMANAS} semanas</strong>
            <span style={{ fontSize: '11.5px', color: C.textMuted }}>— para guardares dinheiro com tempo</span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {depois.slice(0, 8).map((m, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '12.5px' }}>
                <span style={{ display: 'inline-block', width: '7px', height: '7px', borderRadius: '50%', background: CORES_FONTE[m.fonte] || C.textMuted, flexShrink: 0 }} />
                <span style={{ flex: 1, color: C.text }}>{m.titulo}</span>
                <span style={{ color: C.textMuted, whiteSpace: 'nowrap' }}>{new Date(m.data).toLocaleDateString('pt-PT')}</span>
                <span style={{ fontWeight: '700', minWidth: '92px', textAlign: 'right', color: m.tipo === 'entrada' ? C.success : C.danger }}>
                  {m.tipo === 'entrada' ? '+' : '−'}{fmt(m.valor)} €
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
        <h2 style={{ margin: 0, fontSize: '15px', fontWeight: '700', color: C.text }}>Despesas e receitas fora da plataforma</h2>
        <button onClick={() => setNovoMov({ descricao: '', valor: '', tipo: 'saida', data: iso(new Date()), recorrencia: 'mensal', ate: '', notas: '', contaNoLucro: true })}
          style={{ height: '32px', padding: '0 12px', border: 'none', borderRadius: '3px', background: C.primary, color: '#fff', cursor: 'pointer', fontSize: '12px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '6px' }}>
          <Plus size={13} /> Acrescentar
        </button>
      </div>
      <p style={{ margin: '0 0 10px', fontSize: '12px', color: C.textMuted }}>
        Contabilista, renda, seguros, prestações — tudo o que sai da conta e nunca passa pelo site. As recorrentes escrevem-se uma vez.
        {' '}<strong style={{ color: C.text }}>As vendas do marketplace não se lançam aqui</strong> — lançam-se na Previsão,
        e entram nesta projecção sozinhas na data em que o dinheiro cai.
      </p>
      {/* Uma venda lancada nos dois sitios e contada duas vezes. Avisa-se em vez
          de adivinhar qual delas apagar. */}
      {vendasMkt.length > 0 && manuais.some(m => m.tipo === 'entrada' && m.activo) && (
        <div style={{ margin: '0 0 10px', padding: '9px 12px', background: '#fff8e1', border: `1px solid ${C.warning}55`, borderRadius: '4px', fontSize: '11.5px', color: '#92400e', lineHeight: 1.5 }}>
          ⚠ Tens entradas lançadas à mão <em>e</em> vendas de marketplace registadas na Previsão.
          Se alguma dessas entradas for uma venda que já está lá, está a ser contada duas vezes — apaga-a aqui.
        </div>
      )}

      {novoMov && (
        <div id="form-movimento" style={{ background: C.surfaceAlt, border: `1px solid ${C.primary}55`, borderRadius: '6px', padding: '14px', marginBottom: '14px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '10px', alignItems: 'end' }}>
          {novoMov.id && (
            <div style={{ gridColumn: '1 / -1', fontSize: '11.5px', fontWeight: '700', color: C.primary }}>
              A editar um movimento que já existe — Guardar actualiza-o, Cancelar deixa-o como estava.
            </div>
          )}
          <div>
            <label style={rotulo}>Descrição</label>
            <input value={novoMov.descricao} placeholder="Contabilista"
              onChange={e => setNovoMov({ ...novoMov, descricao: e.target.value })} style={campo} />
          </div>
          <div>
            <label style={rotulo}>Valor (€)</label>
            <input type="number" step="0.01" value={novoMov.valor}
              onChange={e => setNovoMov({ ...novoMov, valor: e.target.value })} style={{ ...campo, textAlign: 'right' }} />
          </div>
          <div>
            <label style={rotulo}>Tipo</label>
            <select value={novoMov.tipo} onChange={e => setNovoMov({ ...novoMov, tipo: e.target.value })} style={campo}>
              <option value="saida">Sai da conta</option>
              <option value="entrada">Entra na conta</option>
            </select>
          </div>
          <div>
            <label style={rotulo}>1.ª vez</label>
            <input type="date" value={novoMov.data}
              onChange={e => setNovoMov({ ...novoMov, data: e.target.value })} style={campo} />
          </div>
          <div>
            <label style={rotulo}>Repete</label>
            <select value={novoMov.recorrencia}
              onChange={e => setNovoMov({ ...novoMov, recorrencia: e.target.value, ate: e.target.value === 'nenhuma' ? '' : novoMov.ate })}
              style={campo}>
              <option value="nenhuma">Uma só vez</option>
              <option value="mensal">Todos os meses</option>
              <option value="trimestral">Trimestral</option>
              <option value="anual">Anual</option>
            </select>
          </div>
          {/* O FIM DA RECORRENCIA. Faltava, e sem ele um plano de prestacoes
              repetia-se para sempre: cinco prestacoes dos oculos apareciam nas
              treze semanas todas e em todas as seguintes. A projeccao ficava
              pessimista de forma permanente, que e tao inutil como ser
              optimista — em qualquer dos casos deixa-se de acreditar nela.
              Vazio = nao acaba, para a renda e a internet. */}
          {novoMov.recorrencia !== 'nenhuma' && (
            <div>
              <label style={rotulo}>Última vez</label>
              <input type="date" value={novoMov.ate || ''}
                onChange={e => setNovoMov({ ...novoMov, ate: e.target.value })} style={campo} />
              <div style={{ fontSize: '10px', color: C.textFaint, marginTop: '2px' }}>
                vazio = não acaba
              </div>
            </div>
          )}
          {/* Ninguem pensa "ate 26 de Janeiro" — pensa "sao cinco prestacoes".
              O atalho traduz uma coisa na outra para nao obrigar a contar meses
              de cabeca, que e onde se erra. */}
          {novoMov.recorrencia === 'mensal' && (
            <div>
              <label style={rotulo}>ou nº de prestações</label>
              <input type="number" min="1" max="120" placeholder="5"
                onChange={e => {
                  const n = Number(e.target.value)
                  if (!(n >= 1)) { setNovoMov({ ...novoMov, ate: '' }); return }
                  const d = new Date(novoMov.data + 'T00:00:00')
                  d.setMonth(d.getMonth() + (n - 1))
                  setNovoMov({ ...novoMov, ate: iso(d) })
                }}
                style={campo} />
              <div style={{ fontSize: '10px', color: C.textFaint, marginTop: '2px' }}>
                preenche a data acima
              </div>
            </div>
          )}
          {/* LEVANTAMENTO NAO E DESPESA.
              O dinheiro que sai para a conta pessoal do titular e o lucro a ser
              retirado, nao um custo da empresa. Sai da tesouraria — o dinheiro
              sai mesmo — mas nao pode reduzir o lucro do ano, senao o lucro
              aparece a menos do que e. */}
          <label style={{ gridColumn: '1 / -1', display: 'flex', alignItems: 'flex-start', gap: '7px', padding: '8px 10px', background: novoMov.contaNoLucro === false ? '#fff4ce' : C.surface, border: `1px solid ${novoMov.contaNoLucro === false ? '#c0740055' : C.border}`, borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>
            <input type="checkbox" checked={novoMov.contaNoLucro === false}
              onChange={e => setNovoMov({ ...novoMov, contaNoLucro: !e.target.checked })}
              style={{ cursor: 'pointer', accentColor: C.primary, marginTop: '2px' }} />
            <span>
              <strong>Não é despesa da empresa</strong> — é levantamento meu, ou entrada de capital.
              <div style={{ color: C.textMuted, marginTop: '2px', fontSize: '11px', lineHeight: 1.5 }}>
                Continua a mexer na conta aqui, mas fica de fora do cálculo do lucro no fecho do ano.
                O que tiras para ti é o lucro a sair, não um custo.
              </div>
            </span>
          </label>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={guardarMovimento}
              style={{ flex: 1, height: '32px', border: 'none', borderRadius: '3px', background: C.success, color: '#fff', cursor: 'pointer', fontSize: '12px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
              <Save size={13} /> {novoMov.id ? 'Guardar alterações' : 'Guardar'}
            </button>
            <button onClick={() => setNovoMov(null)}
              style={{ height: '32px', padding: '0 12px', border: `1px solid ${C.border}`, borderRadius: '3px', background: C.surface, cursor: 'pointer', fontSize: '12px', color: C.textMuted }}>
              Cancelar
            </button>
          </div>
        </div>
      )}

      {manuais.length === 0 ? (
        <div style={{ padding: '26px 20px', textAlign: 'center', color: C.textMuted, background: C.surface, border: `1px dashed ${C.border}`, borderRadius: '6px', fontSize: '13px' }}>
          Ainda não há nada. Sem estas despesas, a projecção é optimista de forma sistemática.
        </div>
      ) : (
        <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: '6px', overflow: 'hidden' }}>
          {manuais.map((m, i) => (
            <div key={m.id} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '9px 14px', background: i % 2 ? C.surfaceAlt : C.surface, borderTop: i ? `1px solid ${C.border}` : 'none', opacity: m.activo ? 1 : 0.5 }}>
              {m.tipo === 'entrada'
                ? <ArrowDownRight size={15} color={C.success} />
                : <ArrowUpRight size={15} color={C.danger} />}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '13px', fontWeight: '600', color: C.text }}>
                  {m.descricao}
                  {m.conta_no_lucro === false && (
                    <span style={{ marginLeft: '6px', fontSize: '9.5px', fontWeight: '800', color: '#92400e', background: '#fff4ce', border: '1px solid #c0740055', borderRadius: '3px', padding: '1px 5px' }}>
                      NÃO É DESPESA
                    </span>
                  )}
                </div>
                <div style={{ fontSize: '11px', color: C.textMuted }}>
                  {m.recorrencia === 'nenhuma'
                    ? `uma vez · ${new Date(m.data).toLocaleDateString('pt-PT')}`
                    : `${m.recorrencia} · desde ${new Date(m.data).toLocaleDateString('pt-PT')}`}
                  {m.ate && ` · até ${new Date(m.ate).toLocaleDateString('pt-PT')}`}
                </div>
              </div>
              <div style={{ fontSize: '14px', fontWeight: '700', color: m.tipo === 'entrada' ? C.success : C.danger }}>
                {m.tipo === 'entrada' ? '+' : '−'}{fmt(m.valor)} €
              </div>
              <button onClick={() => editarMovimento(m)} title="Editar"
                style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: C.textMuted, display: 'flex' }}>
                <Pencil size={14} />
              </button>
              <button onClick={() => apagarMovimento(m.id)} title="Apagar"
                style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: C.danger, display: 'flex' }}>
                <Trash2 size={14} />
              </button>
            </div>
          ))}
        </div>
      )}

      <div style={{ marginTop: '20px', display: 'flex', alignItems: 'flex-start', gap: '8px', fontSize: '11.5px', color: C.textMuted, lineHeight: 1.55 }}>
        <Info size={13} style={{ flexShrink: 0, marginTop: '2px' }} />
        <span>
          As datas de recebimento são estimativas — a 2.ª prestação conta-se na data prevista de envio, que é quando se cobra.
          O símbolo <strong>≈</strong> marca valores que ainda podem mudar: compras em previsão sobem quando chega a factura
          final com portes. E o prazo do IVA é configurável, para confirmares com o contabilista.
        </span>
      </div>
    </div>
  )
}
